const postalCodes = [
  { value: 10431, label: "10431 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10432, label: "10432 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10433, label: "10433 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10434, label: "10434 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10435, label: "10435 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10436, label: "10436 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10437, label: "10437 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10438, label: "10438 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10439, label: "10439 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10440, label: "10440 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10441, label: "10441 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10442, label: "10442 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10443, label: "10443 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10444, label: "10444 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10445, label: "10445 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10446, label: "10446 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10447, label: "10447 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10551, label: "10551 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10552, label: "10552 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10553, label: "10553 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10554, label: "10554 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10555, label: "10555 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10556, label: "10556 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10557, label: "10557 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10558, label: "10558 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10559, label: "10559 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10560, label: "10560 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10561, label: "10561 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10562, label: "10562 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10563, label: "10563 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10564, label: "10564 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10671, label: "10671 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10672, label: "10672 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10673, label: "10673 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10674, label: "10674 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10675, label: "10675 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10676, label: "10676 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10677, label: "10677 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10678, label: "10678 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10679, label: "10679 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10680, label: "10680 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10681, label: "10681 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10682, label: "10682 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 10683, label: "10683 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11141, label: "11141 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11142, label: "11142 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11143, label: "11143 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11144, label: "11144 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11145, label: "11145 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11146, label: "11146 ΑΤΤΙΚΗΣ ΓΑΛΑΤΣΙ" },
  { value: 11147, label: "11147 ΑΤΤΙΚΗΣ ΓΑΛΑΤΣΙ" },
  { value: 11251, label: "11251 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11252, label: "11252 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11253, label: "11253 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11254, label: "11254 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11255, label: "11255 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11256, label: "11256 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11257, label: "11257 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11361, label: "11361 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11362, label: "11362 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11363, label: "11363 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11364, label: "11364 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11454, label: "11454 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11471, label: "11471 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11472, label: "11472 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11473, label: "11473 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11474, label: "11474 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11475, label: "11475 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11476, label: "11476 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11521, label: "11521 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11522, label: "11522 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11523, label: "11523 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11524, label: "11524 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11525, label: "11525 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11526, label: "11526 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11527, label: "11527 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11528, label: "11528 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11533, label: "11533 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11551, label: "11551 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11631, label: "11631 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11632, label: "11632 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11633, label: "11633 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11634, label: "11634 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11635, label: "11635 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11636, label: "11636 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11741, label: "11741 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11742, label: "11742 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11743, label: "11743 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11744, label: "11744 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11745, label: "11745 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11835, label: "11835 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11851, label: "11851 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11852, label: "11852 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11853, label: "11853 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11854, label: "11854 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 11855, label: "11855 ΑΤΤΙΚΗΣ ΑΘΗΝΑ" },
  { value: 12131, label: "12131 ΑΤΤΙΚΗΣ ΠΕΡΙΣΤΕΡΙ" },
  { value: 12132, label: "12132 ΑΤΤΙΚΗΣ ΠΕΡΙΣΤΕΡΙ" },
  { value: 12133, label: "12133 ΑΤΤΙΚΗΣ ΠΕΡΙΣΤΕΡΙ" },
  { value: 12134, label: "12134 ΑΤΤΙΚΗΣ ΠΕΡΙΣΤΕΡΙ" },
  { value: 12135, label: "12135 ΑΤΤΙΚΗΣ ΠΕΡΙΣΤΕΡΙ" },
  { value: 12136, label: "12136 ΑΤΤΙΚΗΣ ΠΕΡΙΣΤΕΡΙ" },
  { value: 12137, label: "12137 ΑΤΤΙΚΗΣ ΠΕΡΙΣΤΕΡΙ" },
  { value: 12141, label: "12141 ΑΤΤΙΚΗΣ ΠΕΡΙΣΤΕΡΙ" },
  { value: 12241, label: "12241 ΑΤΤΙΚΗΣ ΑΙΓΑΛΕΩ" },
  { value: 12242, label: "12242 ΑΤΤΙΚΗΣ ΑΙΓΑΛΕΩ" },
  { value: 12243, label: "12243 ΑΤΤΙΚΗΣ ΑΙΓΑΛΕΩ" },
  { value: 12244, label: "12244 ΑΤΤΙΚΗΣ ΑΙΓΑΛΕΩ" },
  { value: 12351, label: "12351 ΑΤΤΙΚΗΣ ΑΓΙΑ ΒΑΡΒΑΡΑ" },
  { value: 12461, label: "12461 ΑΤΤΙΚΗΣ ΧΑΙΔΑΡΙ" },
  { value: 12462, label: "12462 ΑΤΤΙΚΗΣ ΧΑΙΔΑΡΙ" },
  { value: 13076, label: "13076 ΑΤΤΙΚΗΣ ΘΡΑΚΟΜΑΚΕΔΟΝΕΣ" },
  { value: 13121, label: "13121 ΑΤΤΙΚΗΣ ΙΛΙΟΝ" },
  { value: 13122, label: "13122 ΑΤΤΙΚΗΣ ΙΛΙΟΝ" },
  { value: 13123, label: "13123 ΑΤΤΙΚΗΣ ΙΛΙΟΝ" },
  { value: 13231, label: "13231 ΑΤΤΙΚΗΣ ΠΕΤΡΟΥΠΟΛΗ" },
  { value: 13341, label: "13341 ΑΤΤΙΚΗΣ ΑΝΩ ΛΙΟΣΙΑ" },
  { value: 13451, label: "13451 ΑΤΤΙΚΗΣ ΚΑΜΑΤΕΡΟ" },
  { value: 13501, label: "13501 ΑΤΤΙΚΗΣ ΖΕΦΥΡΙ" },
  { value: 13561, label: "13561 ΑΤΤΙΚΗΣ ΑΓΙΟΙ ΑΝΑΡΓΥΡΟΙ" },
  { value: 13562, label: "13562 ΑΤΤΙΚΗΣ ΑΓΙΟΙ ΑΝΑΡΓΥΡΟΙ" },
  { value: 13671, label: "13671 ΑΤΤΙΚΗΣ ΑΧΑΡΝΕΣ" },
  { value: 13672, label: "13672 ΑΤΤΙΚΗΣ ΑΧΑΡΝΕΣ" },
  { value: 13673, label: "13673 ΑΤΤΙΚΗΣ ΑΧΑΡΝΕΣ" },
  { value: 13674, label: "13674 ΑΤΤΙΚΗΣ ΑΧΑΡΝΕΣ" },
  { value: 13675, label: "13675 ΑΤΤΙΚΗΣ ΑΧΑΡΝΕΣ" },
  { value: 13676, label: "13676 ΑΤΤΙΚΗΣ ΘΡΑΚΟΜΑΚΕΔΟΝΕΣ" },
  { value: 13677, label: "13677 ΑΤΤΙΚΗΣ ΑΧΑΡΝΕΣ" },
  { value: 13679, label: "13679 ΑΤΤΙΚΗΣ ΑΜΥΓΔΑΛΕΖΑ"},
  { value: 14121, label: "14121 ΑΤΤΙΚΗΣ ΗΡΑΚΛΕΙΟ" },
  { value: 14122, label: "14122 ΑΤΤΙΚΗΣ ΗΡΑΚΛΕΙΟ" },
  { value: 14123, label: "14123 ΑΤΤΙΚΗΣ ΛΥΚΟΒΡΥΣΗ" },
  { value: 14231, label: "14231 ΑΤΤΙΚΗΣ ΝΕΑ ΙΩΝΙΑ" },
  { value: 14232, label: "14232 ΑΤΤΙΚΗΣ ΝΕΑ ΙΩΝΙΑ" },
  { value: 14233, label: "14233 ΑΤΤΙΚΗΣ ΝΕΑ ΙΩΝΙΑ" },
  { value: 14234, label: "14234 ΑΤΤΙΚΗΣ ΝΕΑ ΙΩΝΙΑ" },
  { value: 14235, label: "14235 ΑΤΤΙΚΗΣ ΝΕΑ ΙΩΝΙΑ" },
  { value: 14341, label: "14341 ΑΤΤΙΚΗΣ ΝΕΑ ΦΙΛΑΔΕΛΦΕΙΑ" },
  { value: 14342, label: "14342 ΑΤΤΙΚΗΣ ΝΕΑ ΦΙΛΑΔΕΛΦΕΙΑ" },
  { value: 14343, label: "14343 ΑΤΤΙΚΗΣ ΝΕΑ ΧΑΛΚΗΔΟΝΑ" },
  { value: 14451, label: "14451 ΑΤΤΙΚΗΣ ΜΕΤΑΜΟΡΦΩΣΗ" },
  { value: 14452, label: "14452 ΑΤΤΙΚΗΣ ΜΕΤΑΜΟΡΦΩΣΗ" },
  { value: 14561, label: "14561 ΑΤΤΙΚΗΣ ΚΗΦΙΣΙΑ" },
  { value: 14562, label: "14562 ΑΤΤΙΚΗΣ ΚΗΦΙΣΙΑ" },
  { value: 14563, label: "14563 ΑΤΤΙΚΗΣ ΚΗΦΙΣΙΑ" },
  { value: 14564, label: "14564 ΑΤΤΙΚΗΣ ΚΗΦΙΣΙΑ" },
  { value: 14565, label: "14565 ΑΤΤΙΚΗΣ ΑΓΙΟΣ ΣΤΕΦΑΝΟΣ" },
  { value: 14568, label: "14568 ΑΤΤΙΚΗΣ ΚΡΥΟΝΕΡΙ" },
  { value: 14569, label: "14569 ΑΤΤΙΚΗΣ ΑΝΟΙΞΗ" },
  { value: 14572, label: "14572 ΑΤΤΙΚΗΣ ΔΡΟΣΙΑ" },
  { value: 14574, label: "14574 ΑΤΤΙΚΗΣ ΡΟΔΟΠΟΛΗ" },
  { value: 14575, label: "14575 ΑΤΤΙΚΗΣ ΣΤΑΜΑΤΑ" },
  { value: 14576, label: "14576 ΑΤΤΙΚΗΣ ΔΙΟΝΥΣΟΣ" },
  { value: 14578, label: "14578 ΑΤΤΙΚΗΣ ΕΚΑΛΗ" },
  { value: 14671, label: "14671 ΑΤΤΙΚΗΣ ΝΕΑ ΕΡΥΘΡΑΙΑ" },
  { value: 15121, label: "15121 ΑΤΤΙΚΗΣ ΠΕΥΚΗ" },
  { value: 15122, label: "15122 ΑΤΤΙΚΗΣ ΜΑΡΟΥΣΙ" },
  { value: 15123, label: "15123 ΑΤΤΙΚΗΣ ΜΑΡΟΥΣΙ" },
  { value: 15124, label: "15124 ΑΤΤΙΚΗΣ ΜΑΡΟΥΣΙ" },
  { value: 15125, label: "15125 ΑΤΤΙΚΗΣ ΜΑΡΟΥΣΙ" },
  { value: 15126, label: "15126 ΑΤΤΙΚΗΣ ΜΑΡΟΥΣΙ" },
  { value: 15127, label: "15127 ΑΤΤΙΚΗΣ ΜΕΛΙΣΣΙΑ" },
  { value: 15231, label: "15231 ΑΤΤΙΚΗΣ ΧΑΛΑΝΔΡΙ" },
  { value: 15232, label: "15232 ΑΤΤΙΚΗΣ ΧΑΛΑΝΔΡΙ" },
  { value: 15233, label: "15233 ΑΤΤΙΚΗΣ ΧΑΛΑΝΔΡΙ" },
  { value: 15234, label: "15234 ΑΤΤΙΚΗΣ ΧΑΛΑΝΔΡΙ" },
  { value: 15235, label: "15235 ΑΤΤΙΚΗΣ ΒΡΙΛΗΣΙΑ" },
  { value: 15236, label: "15236 ΑΤΤΙΚΗΣ ΠΕΝΤΕΛΗ" },
  { value: 15237, label: "15237 ΑΤΤΙΚΗΣ ΦΙΛΟΘΕΗ" },
  { value: 15238, label: "15238 ΑΤΤΙΚΗΣ ΧΑΛΑΝΔΡΙ" },
  { value: 15341, label: "15341 ΑΤΤΙΚΗΣ ΑΓΙΑ ΠΑΡΑΣΚΕΥΗ" },
  { value: 15342, label: "15342 ΑΤΤΙΚΗΣ ΑΓΙΑ ΠΑΡΑΣΚΕΥΗ" },
  { value: 15343, label: "15343 ΑΤΤΙΚΗΣ ΑΓΙΑ ΠΑΡΑΣΚΕΥΗ" },
  { value: 15344, label: "15344 ΑΤΤΙΚΗΣ ΓΕΡΑΚΑΣ" },
  { value: 15349, label: "15349 ΑΤΤΙΚΗΣ ΑΝΘΟΥΣΑ" },
  { value: 15351, label: "15351 ΑΤΤΙΚΗΣ ΠΑΛΛΗΝΗ" },
  { value: 15354, label: "15354 ΑΤΤΙΚΗΣ ΓΛΥΚΑ ΝΕΡΑ" },
  { value: 15451, label: "15451 ΑΤΤΙΚΗΣ ΝΕΟ ΨΥΧΙΚΟ" },
  { value: 15452, label: "15452 ΑΤΤΙΚΗΣ ΨΥΧΙΚΟ" },
  { value: 15561, label: "15561 ΑΤΤΙΚΗΣ ΧΟΛΑΡΓΟΣ" },
  { value: 15562, label: "15562 ΑΤΤΙΚΗΣ ΧΟΛΑΡΓΟΣ" },
  { value: 15669, label: "15669 ΑΤΤΙΚΗΣ ΠΑΠΑΓΟΣ" },
  { value: 15771, label: "15771 ΑΤΤΙΚΗΣ ΖΩΓΡΑΦΟΣ" },
  { value: 15772, label: "15772 ΑΤΤΙΚΗΣ ΖΩΓΡΑΦΟΣ" },
  { value: 15773, label: "15773 ΑΤΤΙΚΗΣ ΖΩΓΡΑΦΟΣ" },
  { value: 16121, label: "16121 ΑΤΤΙΚΗΣ ΚΑΙΣΑΡΙΑΝΗ" },
  { value: 16122, label: "16122 ΑΤΤΙΚΗΣ ΚΑΙΣΑΡΙΑΝΗ" },
  { value: 16231, label: "16231 ΑΤΤΙΚΗΣ ΒΥΡΩΝΑΣ" },
  { value: 16232, label: "16232 ΑΤΤΙΚΗΣ ΒΥΡΩΝΑΣ" },
  { value: 16233, label: "16233 ΑΤΤΙΚΗΣ ΒΥΡΩΝΑΣ" },
  { value: 16341, label: "16341 ΑΤΤΙΚΗΣ ΗΛΙΟΥΠΟΛΗ" },
  { value: 16342, label: "16342 ΑΤΤΙΚΗΣ ΗΛΙΟΥΠΟΛΗ" },
  { value: 16343, label: "16343 ΑΤΤΙΚΗΣ ΗΛΙΟΥΠΟΛΗ" },
  { value: 16344, label: "16344 ΑΤΤΙΚΗΣ ΗΛΙΟΥΠΟΛΗ" },
  { value: 16345, label: "16345 ΑΤΤΙΚΗΣ ΗΛΙΟΥΠΟΛΗ" },
  { value: 16346, label: "16346 ΑΤΤΙΚΗΣ ΗΛΙΟΥΠΟΛΗ" },
  { value: 16450, label: "16450 ΑΤΤΙΚΗΣ ΑΡΓΥΡΟΥΠΟΛΗ" },
  { value: 16451, label: "16451 ΑΤΤΙΚΗΣ ΑΡΓΥΡΟΥΠΟΛΗ" },
  { value: 16452, label: "16452 ΑΤΤΙΚΗΣ ΑΡΓΥΡΟΥΠΟΛΗ" },
  { value: 16552, label: "16552 ΑΤΤΙΚΗΣ ΓΛΥΦΑΔΑ" },
  { value: 16561, label: "16561 ΑΤΤΙΚΗΣ ΓΛΥΦΑΔΑ" },
  { value: 16562, label: "16562 ΑΤΤΙΚΗΣ ΓΛΥΦΑΔΑ" },
  { value: 16671, label: "16671 ΑΤΤΙΚΗΣ ΒΟΥΛΙΑΓΜΕΝΗ" },
  { value: 16672, label: "16672 ΑΤΤΙΚΗΣ ΒΑΡΗ" },
  { value: 16673, label: "16673 ΑΤΤΙΚΗΣ ΒΟΥΛΑ" },
  { value: 16674, label: "16674 ΑΤΤΙΚΗΣ ΓΛΥΦΑΔΑ" },
  { value: 16675, label: "16675 ΑΤΤΙΚΗΣ ΓΛΥΦΑΔΑ" },
  { value: 16777, label: "16777 ΑΤΤΙΚΗΣ ΕΛΛΗΝΙΚΟ" },
  { value: 17121, label: "17121 ΑΤΤΙΚΗΣ ΝΕΑ ΣΜΥΡΝΗ" },
  { value: 17122, label: "17122 ΑΤΤΙΚΗΣ ΝΕΑ ΣΜΥΡΝΗ" },
  { value: 17123, label: "17123 ΑΤΤΙΚΗΣ ΝΕΑ ΣΜΥΡΝΗ" },
  { value: 17124, label: "17124 ΑΤΤΙΚΗΣ ΝΕΑ ΣΜΥΡΝΗ" },
  { value: 17232, label: "17232 ΑΤΤΙΚΗΣ ΔΑΦΝΗ" },
  { value: 17234, label: "17234 ΑΤΤΙΚΗΣ ΔΑΦΝΗ" },
  { value: 17235, label: "17235 ΑΤΤΙΚΗΣ ΔΑΦΝΗ" },
  { value: 17236, label: "17236 ΑΤΤΙΚΗΣ ΑΓΙΟΣ ΔΗΜΗΤΡΙΟΣ" },
  { value: 17237, label: "17237 ΑΤΤΙΚΗΣ ΥΜΗΤΤΟΣ" },
  { value: 17341, label: "17341 ΑΤΤΙΚΗΣ ΑΓΙΟΣ ΔΗΜΗΤΡΙΟΣ" },
  { value: 17342, label: "17342 ΑΤΤΙΚΗΣ ΑΓΙΟΣ ΔΗΜΗΤΡΙΟΣ" },
  { value: 17343, label: "17343 ΑΤΤΙΚΗΣ ΑΓΙΟΣ ΔΗΜΗΤΡΙΟΣ" },
  { value: 17455, label: "17455 ΑΤΤΙΚΗΣ ΑΛΙΜΟΣ" },
  { value: 17456, label: "17456 ΑΤΤΙΚΗΣ ΑΛΙΜΟΣ" },
  { value: 17561, label: "17561 ΑΤΤΙΚΗΣ ΠΑΛΑΙΟ ΦΑΛΗΡΟ" },
  { value: 17562, label: "17562 ΑΤΤΙΚΗΣ ΠΑΛΑΙΟ ΦΑΛΗΡΟ" },
  { value: 17563, label: "17563 ΑΤΤΙΚΗΣ ΠΑΛΑΙΟ ΦΑΛΗΡΟ" },
  { value: 17564, label: "17564 ΑΤΤΙΚΗΣ ΠΑΛΑΙΟ ΦΑΛΗΡΟ" },
  { value: 17671, label: "17671 ΑΤΤΙΚΗΣ ΚΑΛΛΙΘΕΑ" },
  { value: 17672, label: "17672 ΑΤΤΙΚΗΣ ΚΑΛΛΙΘΕΑ" },
  { value: 17673, label: "17673 ΑΤΤΙΚΗΣ ΚΑΛΛΙΘΕΑ" },
  { value: 17674, label: "17674 ΑΤΤΙΚΗΣ ΚΑΛΛΙΘΕΑ" },
  { value: 17675, label: "17675 ΑΤΤΙΚΗΣ ΚΑΛΛΙΘΕΑ" },
  { value: 17676, label: "17676 ΑΤΤΙΚΗΣ ΚΑΛΛΙΘΕΑ" },
  { value: 17778, label: "17778 ΑΤΤΙΚΗΣ ΤΑΥΡΟΣ" },
  { value: 18010, label: "18010 ΑΤΤΙΚΗΣ ΑΙΓΙΝΑ" },
  { value: 18020, label: "18020 ΑΤΤΙΚΗΣ ΠΟΡΟΣ ΤΡΟΙΖΗΝΙΑΣ" },
  { value: 18030, label: "18030 ΑΤΤΙΚΗΣ ΜΕΘΑΝΑ" },
  { value: 18040, label: "18040 ΑΤΤΙΚΗΣ ΥΔΡΑ" },
  { value: 18050, label: "18050 ΑΤΤΙΚΗΣ ΣΠΕΤΣΕΣ" },
  { value: 18120, label: "18120 ΑΤΤΙΚΗΣ ΚΟΡΥΔΑΛΛΟΣ" },
  { value: 18121, label: "18121 ΑΤΤΙΚΗΣ ΚΟΡΥΔΑΛΛΟΣ" },
  { value: 18122, label: "18122 ΑΤΤΙΚΗΣ ΚΟΡΥΔΑΛΛΟΣ" },
  { value: 18233, label: "18233 ΑΤΤΙΚΗΣ ΑΓΙΟΣ ΙΩΑΝΝΗΣ ΡΕΝΤΗΣ" },
  { value: 18344, label: "18344 ΑΤΤΙΚΗΣ ΜΟΣΧΑΤΟ" },
  { value: 18345, label: "18345 ΑΤΤΙΚΗΣ ΜΟΣΧΑΤΟ" },
  { value: 18346, label: "18346 ΑΤΤΙΚΗΣ ΜΟΣΧΑΤΟ" },
  { value: 18450, label: "18450 ΑΤΤΙΚΗΣ ΝΙΚΑΙΑ" },
  { value: 18451, label: "18451 ΑΤΤΙΚΗΣ ΝΙΚΑΙΑ" },
  { value: 18452, label: "18452 ΑΤΤΙΚΗΣ ΝΙΚΑΙΑ" },
  { value: 18453, label: "18453 ΑΤΤΙΚΗΣ ΝΙΚΑΙΑ" },
  { value: 18454, label: "18454 ΑΤΤΙΚΗΣ ΝΙΚΑΙΑ" },
  { value: 18531, label: "18531 ΑΤΤΙΚΗΣ ΠΕΙΡΑΙΑΣ" },
  { value: 18532, label: "18532 ΑΤΤΙΚΗΣ ΠΕΙΡΑΙΑΣ" },
  { value: 18533, label: "18533 ΑΤΤΙΚΗΣ ΠΕΙΡΑΙΑΣ" },
  { value: 18534, label: "18534 ΑΤΤΙΚΗΣ ΠΕΙΡΑΙΑΣ" },
  { value: 18535, label: "18535 ΑΤΤΙΚΗΣ ΠΕΙΡΑΙΑΣ" },
  { value: 18536, label: "18536 ΑΤΤΙΚΗΣ ΠΕΙΡΑΙΑΣ" },
  { value: 18537, label: "18537 ΑΤΤΙΚΗΣ ΠΕΙΡΑΙΑΣ" },
  { value: 18538, label: "18538 ΑΤΤΙΚΗΣ ΠΕΙΡΑΙΑΣ" },
  { value: 18539, label: "18539 ΑΤΤΙΚΗΣ ΠΕΙΡΑΙΑΣ" },
  { value: 18540, label: "18540 ΑΤΤΙΚΗΣ ΠΕΙΡΑΙΑΣ" },
  { value: 18541, label: "18541 ΑΤΤΙΚΗΣ ΠΕΙΡΑΙΑΣ" },
  { value: 18542, label: "18542 ΑΤΤΙΚΗΣ ΠΕΙΡΑΙΑΣ" },
  { value: 18543, label: "18543 ΑΤΤΙΚΗΣ ΠΕΙΡΑΙΑΣ" },
  { value: 18544, label: "18544 ΑΤΤΙΚΗΣ ΠΕΙΡΑΙΑΣ" },
  { value: 18545, label: "18545 ΑΤΤΙΚΗΣ ΠΕΙΡΑΙΑΣ" },
  { value: 18546, label: "18546 ΑΤΤΙΚΗΣ ΠΕΙΡΑΙΑΣ" },
  { value: 18547, label: "18547 ΑΤΤΙΚΗΣ ΠΕΙΡΑΙΑΣ" },
  { value: 18648, label: "18648 ΑΤΤΙΚΗΣ ΔΡΑΠΕΤΣΩΝΑ" },
  { value: 18755, label: "18755 ΑΤΤΙΚΗΣ ΚΕΡΑΤΣΙΝΙ" },
  { value: 18756, label: "18756 ΑΤΤΙΚΗΣ ΚΕΡΑΤΣΙΝΙ" },
  { value: 18757, label: "18757 ΑΤΤΙΚΗΣ ΚΕΡΑΤΣΙΝΙ" },
  { value: 18758, label: "18758 ΑΤΤΙΚΗΣ ΚΕΡΑΤΣΙΝΙ" },
  { value: 18863, label: "18863 ΑΤΤΙΚΗΣ ΠΕΡΑΜΑ" },
  { value: 18900, label: "18900 ΑΤΤΙΚΗΣ ΣΑΛΑΜΙΝΑ" },
  { value: 18901, label: "18901 ΑΤΤΙΚΗΣ ΠΑΛΟΥΚΙΑ" },
  { value: 18902, label: "18902 ΑΤΤΙΚΗΣ ΑΜΠΕΛΑΚΙΑ" },
  { value: 18903, label: "18903 ΑΤΤΙΚΗΣ ΑΙΑΝΤΕΙΟ" },
  { value: 19001, label: "19001 ΑΤΤΙΚΗΣ ΚΕΡΑΤΕΑ" },
  { value: 19002, label: "19002 ΑΤΤΙΚΗΣ ΠΑΙΑΝΙΑ" },
  { value: 19003, label: "19003 ΑΤΤΙΚΗΣ ΜΑΡΚΟΠΟΥΛΟ" },
  { value: 19004, label: "19004 ΑΤΤΙΚΗΣ ΣΠΑΤΑ" },
  { value: 19005, label: "19005 ΑΤΤΙΚΗΣ ΝΕΑ ΜΑΚΡΗ" },
  { value: 19006, label: "19006 ΑΤΤΙΚΗΣ ΝΕΑ ΠΕΡΑΜΟΣ" },
  { value: 19007, label: "19007 ΑΤΤΙΚΗΣ ΜΑΡΑΘΩΝΑΣ" },
  { value: 19008, label: "19008 ΑΤΤΙΚΗΣ ΕΡΥΘΡΕΣ" },
  { value: 19009, label: "19009 ΑΤΤΙΚΗΣ ΡΑΦΗΝΑ" },
  { value: 19010, label: "19010 ΑΤΤΙΚΗΣ ΚΑΛΥΒΙΑ ΘΟΡΙΚΟΥ" },
  { value: 19011, label: "19011 ΑΤΤΙΚΗΣ ΑΥΛΩΝΑ" },
  { value: 19012, label: "19012 ΑΤΤΙΚΗΣ ΒΙΛΙΑ" },
  { value: 19013, label: "19013 ΑΤΤΙΚΗΣ ΑΝΑΒΥΣΣΟΣ" },
  { value: 19014, label: "19014 ΑΤΤΙΚΗΣ ΚΑΠΑΝΔΡΙΤΙ" },
  { value: 19015, label: "19015 ΑΤΤΙΚΗΣ ΝΕΑ ΠΑΛΑΤΙΑ" },
  { value: 19016, label: "19016 ΑΤΤΙΚΗΣ ΑΡΤΕΜΙΣ" },
  { value: 19018, label: "19018 ΑΤΤΙΚΗΣ ΜΑΓΟΥΛΑ" },
  { value: 19100, label: "19100 ΑΤΤΙΚΗΣ ΜΕΓΑΡΑ" },
  { value: 19200, label: "19200 ΑΤΤΙΚΗΣ ΕΛΕΥΣΙΝΑ" },
  { value: 19300, label: "19300 ΑΤΤΙΚΗΣ ΑΣΠΡΟΠΥΡΓΟΣ" },
  { value: 19400, label: "19400 ΑΤΤΙΚΗΣ ΚΟΡΟΠΙ" },
  { value: 19500, label: "19500 ΑΤΤΙΚΗΣ ΛΑΥΡΙΟ" },
  { value: 19600, label: "19600 ΑΤΤΙΚΗΣ ΜΑΝΔΡΑ" },
  { value: 20001, label: "20001 ΚΟΡΙΝΘΙΑΣ ΖΕΥΓΟΛΑΤΕΙΟ" },
  { value: 20002, label: "20002 ΚΟΡΙΝΘΙΑΣ ΒΕΛΟ" },
  { value: 20003, label: "20003 ΚΟΡΙΝΘΙΑΣ ΑΓΙΟΙ ΘΕΟΔΩΡΟΙ" },
  { value: 20004, label: "20004 ΚΟΡΙΝΘΙΑΣ ΣΟΦΙΚΟ" },
  { value: 20005, label: "20005 ΚΟΡΙΝΘΙΑΣ ΑΘΙΚΙΑ" },
  { value: 20006, label: "20006 ΚΟΡΙΝΘΙΑΣ ΒΡΑΧΑΤΙ" },
  { value: 20007, label: "20007 ΚΟΡΙΝΘΙΑΣ ΑΡΧΑΙΑ ΚΟΡΙΝΘΟΣ" },
  { value: 20008, label: "20008 ΚΟΡΙΝΘΙΑΣ ΧΙΛΙΟΜΟΔΙ" },
  { value: 20009, label: "20009 ΚΟΡΙΝΘΙΑΣ ΔΕΡΒΕΝΙ" },
  { value: 20010, label: "20010 ΚΟΡΙΝΘΙΑΣ ΙΣΘΜΙΑ" },
  { value: 20011, label: "20011 ΚΟΡΙΝΘΙΑΣ ΠΕΡΙΓΙΑΛΙ" },
  { value: 20012, label: "20012 ΚΟΡΙΝΘΙΑΣ ΛΥΚΟΠΟΡΙΑ" },
  { value: 20013, label: "20013 ΚΟΡΙΝΘΙΑΣ ΠΙΤΣΑ" },
  { value: 20014, label: "20014 ΚΟΡΙΝΘΙΑΣ ΓΚΟΥΡΑ" },
  { value: 20015, label: "20015 ΚΟΡΙΝΘΙΑΣ ΣΟΥΛΙ" },
  { value: 20016, label: "20016 ΚΟΡΙΝΘΙΑΣ ΚΑΛΙΑΝΟΙ" },
  { value: 20017, label: "20017 ΚΟΡΙΝΘΙΑΣ ΚΛΗΜΕΝΤΙ" },
  { value: 20100, label: "20100 ΚΟΡΙΝΘΙΑΣ ΚΟΡΙΝΘΟΣ" },
  { value: 20131, label: "20131 ΚΟΡΙΝΘΙΑΣ ΚΟΡΙΝΘΟΣ" },
  { value: 20132, label: "20132 ΚΟΡΙΝΘΙΑΣ ΚΟΡΙΝΘΟΣ" },
  { value: 20200, label: "20200 ΚΟΡΙΝΘΙΑΣ ΚΙΑΤΟ" },
  { value: 20300, label: "20300 ΚΟΡΙΝΘΙΑΣ ΛΟΥΤΡΑΚΙ" },
  { value: 20400, label: "20400 ΚΟΡΙΝΘΙΑΣ ΞΥΛΟΚΑΣΤΡΟ" },
  { value: 20500, label: "20500 ΚΟΡΙΝΘΙΑΣ ΝΕΜΕΑ" },
  { value: 21051, label: "21051 ΑΡΓΟΛΙΔΑΣ ΕΡΜΙΟΝΗ" },
  { value: 21052, label: "21052 ΑΡΓΟΛΙΔΑΣ ΛΥΓΟΥΡΙΟ" },
  { value: 21053, label: "21053 ΑΡΓΟΛΙΔΑΣ ΝΕΑ ΚΙΟΣ" },
  { value: 21054, label: "21054 ΑΡΓΟΛΙΔΑΣ ΝΕΑ ΕΠΙΔΑΥΡΟΣ" },
  { value: 21055, label: "21055 ΑΡΓΟΛΙΔΑΣ ΑΓΙΑ ΤΡΙΑΔΑ ΑΡΓΟΛΙΔ." },
  { value: 21056, label: "21056 ΑΡΓΟΛΙΔΑΣ ΤΟΛΟ" },
  { value: 21057, label: "21057 ΑΡΓΟΛΙΔΑΣ ΑΧΛΑΔΟΚΑΜΠΟΣ" },
  { value: 21058, label: "21058 ΑΡΓΟΛΙΔΑΣ ΛΥΡΚΕΙΑ" },
  { value: 21059, label: "21059 ΑΡΓΟΛΙΔΑΣ ΠΑΛΑΙΑ ΕΠΙΔΑΥΡΟΣ" },
  { value: 21060, label: "21060 ΑΡΓΟΛΙΔΑΣ ΔΡΕΠΑΝΟ" },
  { value: 21061, label: "21061 ΑΡΓΟΛΙΔΑΣ ΠΟΡΤΟΧΕΛΙ" },
  { value: 21100, label: "21100 ΑΡΓΟΛΙΔΑΣ ΝΑΥΠΛΙΟ" },
  { value: 21200, label: "21200 ΑΡΓΟΛΙΔΑΣ ΑΡΓΟΣ" },
  { value: 21231, label: "21231 ΑΡΓΟΛΙΔΑΣ ΑΡΓΟΣ" },
  { value: 21232, label: "21232 ΑΡΓΟΛΙΔΑΣ ΑΡΓΟΣ" },
  { value: 21300, label: "21300 ΑΡΓΟΛΙΔΑΣ ΚΡΑΝΙΔΙ" },
  { value: 22001, label: "22001 ΑΡΚΑΔΙΑΣ ΑΣΤΡΟΣ" },
  { value: 22002, label: "22002 ΑΡΚΑΔΙΑΣ ΛΕΒΙΔΙ" },
  { value: 22003, label: "22003 ΑΡΚΑΔΙΑΣ ΛΑΓΚΑΔΙΑ" },
  { value: 22004, label: "22004 ΑΡΚΑΔΙΑΣ ΚΑΝΔΗΛΑ" },
  { value: 22005, label: "22005 ΑΡΚΑΔΙΑΣ ΝΕΣΤΑΝΗ" },
  { value: 22006, label: "22006 ΑΡΚΑΔΙΑΣ ΑΓΙΟΣ ΑΝΔΡΕΑΣ" },
  { value: 22007, label: "22007 ΑΡΚΑΔΙΑΣ ΔΗΜΗΤΣΑΝΑ" },
  { value: 22008, label: "22008 ΑΡΚΑΔΙΑΣ ΤΡΟΠΑΙΑ" },
  { value: 22009, label: "22009 ΑΡΚΑΔΙΑΣ ΑΓΙΟΣ ΠΕΤΡΟΣ" },
  { value: 22010, label: "22010 ΑΡΚΑΔΙΑΣ ΒΥΤΙΝΑ" },
  { value: 22011, label: "22011 ΑΡΚΑΔΙΑΣ ΚΟΛΛΙΝΕΣ" },
  { value: 22012, label: "22012 ΑΡΚΑΔΙΑΣ ΣΤΑΔΙΟ" },
  { value: 22013, label: "22013 ΑΡΚΑΔΙΑΣ ΚΑΣΤΡΙ" },
  { value: 22014, label: "22014 ΑΡΚΑΔΙΑΣ ΒΑΛΤΕΣΙΝΙΚΟ" },
  { value: 22015, label: "22015 ΑΡΚΑΔΙΑΣ ΚΟΝΤΟΒΑΖΑΙΝΑ" },
  { value: 22016, label: "22016 ΑΡΚΑΔΙΑΣ ΒΛΑΧΟΚΕΡΑΣΙΑ" },
  { value: 22017, label: "22017 ΑΡΚΑΔΙΑΣ ΔΑΡΑΣ" },
  { value: 22018, label: "22018 ΑΡΚΑΔΙΑΣ ΕΛΑΙΟΧΩΡΙ" },
  { value: 22019, label: "22019 ΑΡΚΑΔΙΑΣ ΠΑΡΑΛΙΟ ΑΣΤΡΟΣ" },
  { value: 22020, label: "22020 ΑΡΚΑΔΙΑΣ ΚΟΣΜΑΣ" },
  { value: 22021, label: "22021 ΑΡΚΑΔΙΑΣ ΛΕΟΝΤΑΡΙ" },
  { value: 22022, label: "22022 ΑΡΚΑΔΙΑΣ ΚΑΡΙΤΑΙΝΑ" },
  { value: 22024, label: "22024 ΑΡΚΑΔΙΑΣ ΣΤΕΜΝΙΤΣΑ" },
  { value: 22025, label: "22025 ΑΡΚΑΔΙΑΣ ΙΣΑΡΗΣ" },
  { value: 22026, label: "22026 ΑΡΚΑΔΙΑΣ ΜΑΓΟΥΛΙΑΝΑ" },
  { value: 22027, label: "22027 ΑΡΚΑΔΙΑΣ ΚΑΤΩ ΑΣΕΑ" },
  { value: 22028, label: "22028 ΑΡΚΑΔΙΑΣ ΠΑΛΟΥΜΠΑ" },
  { value: 22100, label: "22100 ΑΡΚΑΔΙΑΣ ΤΡΙΠΟΛΗ" },
  { value: 22131, label: "22131 ΑΡΚΑΔΙΑΣ ΤΡΙΠΟΛΗ" },
  { value: 22132, label: "22132 ΑΡΚΑΔΙΑΣ ΤΡΙΠΟΛΗ" },
  { value: 22200, label: "22200 ΑΡΚΑΔΙΑΣ ΜΕΓΑΛΟΠΟΛΗ" },
  { value: 22300, label: "22300 ΑΡΚΑΔΙΑΣ ΛΕΩΝΙΔΙ" },
  { value: 23051, label: "23051 ΛΑΚΩΝΙΑΣ ΣΚΑΛΑ" },
  { value: 23052, label: "23052 ΛΑΚΩΝΙΑΣ ΜΟΛΑΟΙ" },
  { value: 23053, label: "23053 ΛΑΚΩΝΙΑΣ ΝΕΑΠΟΛΗ ΛΑΚΩΝΙΑΣ" },
  { value: 23054, label: "23054 ΛΑΚΩΝΙΑΣ ΞΗΡΟΚΑΜΠΙ" },
  { value: 23055, label: "23055 ΛΑΚΩΝΙΑΣ ΒΛΑΧΙΩΤΗΣ" },
  { value: 23056, label: "23056 ΛΑΚΩΝΙΑΣ ΠΑΠΑΔΙΑΝΙΚΑ" },
  { value: 23057, label: "23057 ΛΑΚΩΝΙΑΣ ΚΡΟΚΕΕΣ" },
  { value: 23058, label: "23058 ΛΑΚΩΝΙΑΣ ΓΕΡΑΚΙ" },
  { value: 23059, label: "23059 ΛΑΚΩΝΙΑΣ ΚΑΣΤΟΡΕΙΟ" },
  { value: 23060, label: "23060 ΛΑΚΩΝΙΑΣ ΝΙΑΤΑ" },
  { value: 23061, label: "23061 ΛΑΚΩΝΙΑΣ ΑΓΙΟΣ ΝΙΚΟΛΑΟΣ ΛΑΚΩΝ" },
  { value: 23062, label: "23062 ΛΑΚΩΝΙΑΣ ΑΡΕΟΠΟΛΗ" },
  { value: 23063, label: "23063 ΛΑΚΩΝΙΑΣ ΠΥΡΓΟΣ ΔΙΡΟΥ" },
  { value: 23064, label: "23064 ΛΑΚΩΝΙΑΣ ΣΕΛΑΣΙΑ" },
  { value: 23065, label: "23065 ΛΑΚΩΝΙΑΣ ΓΕΩΡΓΙΤΣΙ" },
  { value: 23066, label: "23066 ΛΑΚΩΝΙΑΣ ΚΟΤΡΩΝΑΣ" },
  { value: 23067, label: "23067 ΛΑΚΩΝΙΑΣ ΚΑΡΥΕΣ ΛΑΚΩΝΙΑΣ" },
  { value: 23068, label: "23068 ΛΑΚΩΝΙΑΣ ΡΕΙΧΕΑ" },
  { value: 23069, label: "23069 ΛΑΚΩΝΙΑΣ ΚΑΣΤΟΡΕΙΟ" },
  { value: 23070, label: "23070 ΛΑΚΩΝΙΑΣ ΜΟΝΕΜΒΑΣΙΑ" },
  { value: 23071, label: "23071 ΛΑΚΩΝΙΑΣ ΓΕΡΟΛΙΜΕΝΑΣ" },
  { value: 23100, label: "23100 ΛΑΚΩΝΙΑΣ ΣΠΑΡΤΗ" },
  { value: 23200, label: "23200 ΛΑΚΩΝΙΑΣ ΓΥΘΕΙΟ" },
  { value: 24001, label: "24001 ΜΕΣΣΗΝΙΑΣ ΠΥΛΟΣ" },
  { value: 24002, label: "24002 ΜΕΣΣΗΝΙΑΣ ΜΕΛΙΓΑΛΑΣ" },
  { value: 24003, label: "24003 ΜΕΣΣΗΝΙΑΣ ΚΟΠΑΝΑΚΙ" },
  { value: 24004, label: "24004 ΜΕΣΣΗΝΙΑΣ ΚΟΡΩΝΗ" },
  { value: 24005, label: "24005 ΜΕΣΣΗΝΙΑΣ ΠΕΤΑΛΙΔΙ" },
  { value: 24006, label: "24006 ΜΕΣΣΗΝΙΑΣ ΜΕΘΩΝΗ" },
  { value: 24007, label: "24007 ΜΕΣΣΗΝΙΑΣ ΑΡΦΑΡΑ" },
  { value: 24008, label: "24008 ΜΕΣΣΗΝΙΑΣ ΔΙΑΒΟΛΙΤΣΙ" },
  { value: 24009, label: "24009 ΜΕΣΣΗΝΙΑΣ ΘΟΥΡΙΑ" },
  { value: 24010, label: "24010 ΜΕΣΣΗΝΙΑΣ ΛΟΓΓΑ" },
  { value: 24011, label: "24011 ΜΕΣΣΗΝΙΑΣ ΔΩΡΙΟ" },
  { value: 24012, label: "24012 ΜΕΣΣΗΝΙΑΣ ΑΡΙΣ" },
  { value: 24013, label: "24013 ΜΕΣΣΗΝΙΑΣ ΑΝΔΡΟΥΣΑ" },
  { value: 24014, label: "24014 ΜΕΣΣΗΝΙΑΣ ΧΑΤΖΗΣ" },
  { value: 24015, label: "24015 ΜΕΣΣΗΝΙΑΣ ΑΡΙΣΤΟΜΕΝΗΣ" },
  { value: 24016, label: "24016 ΜΕΣΣΗΝΙΑΣ ΚΑΜΠΟΣ" },
  { value: 24017, label: "24017 ΜΕΣΣΗΝΙΑΣ ΑΕΤΟΣ" },
  { value: 24018, label: "24018 ΜΕΣΣΗΝΙΑΣ ΨΑΡΙ" },
  { value: 24019, label: "24019 ΜΕΣΣΗΝΙΑΣ ΟΙΧΑΛΙΑ" },
  { value: 24020, label: "24020 ΜΕΣΣΗΝΙΑΣ ΑΛΑΓΟΝΙΑ" },
  { value: 24021, label: "24021 ΜΕΣΣΗΝΙΑΣ ΣΙΔΗΡΟΚΑΣΤΡΟ ΜΕΣΣΗΝΙ" },
  { value: 24022, label: "24022 ΜΕΣΣΗΝΙΑΣ ΚΑΡΔΑΜΥΛΗ" },
  { value: 24023, label: "24023 ΜΕΣΣΗΝΙΑΣ ΠΛΑΤΣΑ" },
  { value: 24024, label: "24024 ΜΕΣΣΗΝΙΑΣ ΑΓΙΟΣ ΝΙΚΟΛΑΟΣ ΜΕΣΣΗ" },
  { value: 24100, label: "24100 ΜΕΣΣΗΝΙΑΣ ΚΑΛΑΜΑΤΑ" },
  { value: 24101, label: "24101 ΜΕΣΣΗΝΙΑΣ ΚΑΛΑΜΑΤΑ" },
  { value: 24131, label: "24131 ΜΕΣΣΗΝΙΑΣ ΚΑΛΑΜΑΤΑ" },
  { value: 24132, label: "24132 ΜΕΣΣΗΝΙΑΣ ΚΑΛΑΜΑΤΑ" },
  { value: 24133, label: "24133 ΜΕΣΣΗΝΙΑΣ ΚΑΛΑΜΑΤΑ" },
  { value: 24134, label: "24134 ΜΕΣΣΗΝΙΑΣ ΚΑΛΑΜΑΤΑ" },
  { value: 24200, label: "24200 ΜΕΣΣΗΝΙΑΣ ΜΕΣΣΗΝΗ" },
  { value: 24300, label: "24300 ΜΕΣΣΗΝΙΑΣ ΦΙΛΙΑΤΡΑ" },
  { value: 24400, label: "24400 ΜΕΣΣΗΝΙΑΣ ΓΑΡΓΑΛΙΑΝΟΙ" },
  { value: 24500, label: "24500 ΜΕΣΣΗΝΙΑΣ ΚΥΠΑΡΙΣΣΙΑ" },
  { value: 24600, label: "24600 ΜΕΣΣΗΝΙΑΣ ΧΩΡΑ" },
  { value: 25001, label: "25001 ΑΧΑΙΑΣ ΚΑΛΑΒΡΥΤΑ" },
  { value: 25002, label: "25002 ΑΧΑΙΑΣ ΒΡΑΧΝΑΙΙΚΑ" },
  { value: 25003, label: "25003 ΑΧΑΙΑΣ ΔΙΑΚΟΠΤΟ" },
  { value: 25004, label: "25004 ΑΧΑΙΑΣ ΔΑΦΝΗ" },
  { value: 25005, label: "25005 ΑΧΑΙΑΣ ΣΑΓΑΙΙΚΑ" },
  { value: 25006, label: "25006 ΑΧΑΙΑΣ ΑΚΡΑΤΑ" },
  { value: 25007, label: "25007 ΑΧΑΙΑΣ ΚΛΕΙΤΟΡΙΑ" },
  { value: 25008, label: "25008 ΑΧΑΙΑΣ ΧΑΛΑΝΔΡΙΤΣΑ" },
  { value: 25009, label: "25009 ΑΧΑΙΑΣ ΚΑΜΑΡΕΣ" },
  { value: 25010, label: "25010 ΑΧΑΙΑΣ ΑΙΓΕΙΡΑ" },
  { value: 25011, label: "25011 ΑΧΑΙΑΣ ΚΕΡΤΕΖΗ" },
  { value: 25012, label: "25012 ΑΧΑΙΑΣ ΛΙΒΑΡΤΖΙ" },
  { value: 25013, label: "25013 ΑΧΑΙΑΣ ΜΑΝΕΣΙ" },
  { value: 25014, label: "25014 ΑΧΑΙΑΣ ΠΛΑΤΑΝΟΣ" },
  { value: 25015, label: "25015 ΑΧΑΙΑΣ ΕΡΥΜΑΝΘΕΙΑ" },
  { value: 25016, label: "25016 ΑΧΑΙΑΣ ΑΡΟΑΝΙΑ" },
  { value: 25017, label: "25017 ΑΧΑΙΑΣ ΚΕΡΠΙΝΗ" },
  { value: 25018, label: "25018 ΑΧΑΙΑΣ ΒΙ.ΠΕ. ΠΑΤΡΩΝ" },
  { value: 25100, label: "25100 ΑΧΑΙΑΣ ΑΙΓΙΟ" },
  { value: 25200, label: "25200 ΑΧΑΙΑΣ ΚΑΤΩ ΑΧΑΙΑ" },
  { value: 26221, label: "26221 ΑΧΑΙΑΣ ΠΑΤΡΑ" },
  { value: 26222, label: "26222 ΑΧΑΙΑΣ ΠΑΤΡΑ" },
  { value: 26223, label: "26223 ΑΧΑΙΑΣ ΠΑΤΡΑ" },
  { value: 26224, label: "26224 ΑΧΑΙΑΣ ΠΑΤΡΑ" },
  { value: 26225, label: "26225 ΑΧΑΙΑΣ ΠΑΤΡΑ" },
  { value: 26226, label: "26226 ΑΧΑΙΑΣ ΠΑΤΡΑ" },
  { value: 26234, label: "26234 ΑΧΑΙΑΣ ΠΑΤΡΑ" },
  { value: 26331, label: "26331 ΑΧΑΙΑΣ ΠΑΤΡΑ" },
  { value: 26332, label: "26332 ΑΧΑΙΑΣ ΠΑΤΡΑ" },
  { value: 26333, label: "26333 ΑΧΑΙΑΣ ΠΑΤΡΑ" },
  { value: 26334, label: "26334 ΑΧΑΙΑΣ ΠΑΤΡΑ" },
  { value: 26335, label: "26335 ΑΧΑΙΑΣ ΠΑΤΡΑ" },
  { value: 26441, label: "26441 ΑΧΑΙΑΣ ΠΑΤΡΑ" },
  { value: 26442, label: "26442 ΑΧΑΙΑΣ ΠΑΤΡΑ" },
  { value: 26443, label: "26443 ΑΧΑΙΑΣ ΠΑΤΡΑ" },
  { value: 26444, label: "26444 ΑΧΑΙΑΣ ΠΑΤΡΑ" },
  { value: 26500, label: "26500 ΑΧΑΙΑΣ ΠΑΤΡΑ" },
  { value: 26504, label: "26504 ΑΧΑΙΑΣ ΠΑΤΡΑΣ 4" },
  { value: 27050, label: "27050 ΗΛΕΙΑΣ ΒΑΡΘΟΛΟΜΙΟ" },
  { value: 27051, label: "27051 ΗΛΕΙΑΣ ΑΝΔΡΑΒΙΔΑ" },
  { value: 27052, label: "27052 ΗΛΕΙΑΣ Σ. Σ. ΒΑΡΔΑΣ" },
  { value: 27053, label: "27053 ΗΛΕΙΑΣ ΛΕΧΑΙΝΑ" },
  { value: 27054, label: "27054 ΗΛΕΙΑΣ ΖΑΧΑΡΩ" },
  { value: 27055, label: "27055 ΗΛΕΙΑΣ ΚΡΕΣΤΕΝΑ" },
  { value: 27056, label: "27056 ΗΛΕΙΑΣ ΝΕΑ ΦΙΓΑΛΕΙΑ" },
  { value: 27057, label: "27057 ΗΛΕΙΑΣ ΤΡΑΓΑΝΟ" },
  { value: 27058, label: "27058 ΗΛΕΙΑΣ ΕΠΙΤΑΛΙΟ" },
  { value: 27059, label: "27059 ΗΛΕΙΑΣ ΧΑΒΑΡΙ" },
  { value: 27060, label: "27060 ΗΛΕΙΑΣ ΠΕΛΟΠΙΟ ΗΛ." },
  { value: 27061, label: "27061 ΗΛΕΙΑΣ ΑΝΔΡΙΤΣΑΙΝΑ" },
  { value: 27062, label: "27062 ΗΛΕΙΑΣ ΚΑΛΛΙΘΕΑ ΗΛΕΙΑΣ" },
  { value: 27063, label: "27063 ΗΛΕΙΑΣ ΛΑΜΠΕΙΑ" },
  { value: 27064, label: "27064 ΗΛΕΙΑΣ ΚΑΡΑΤΟΥΛΑ" },
  { value: 27065, label: "27065 ΗΛΕΙΑΣ ΑΡΧΑΙΑ ΟΛΥΜΠΙΑ" },
  { value: 27066, label: "27066 ΗΛΕΙΑΣ ΛΑΛΑΣ" },
  { value: 27067, label: "27067 ΗΛΕΙΑΣ ΚΑΤΑΚΟΛΟ" },
  { value: 27068, label: "27068 ΗΛΕΙΑΣ ΚΥΛΛΗΝΗ" },
  { value: 27069, label: "27069 ΗΛΕΙΑΣ ΕΦΥΡΑ" },
  { value: 27100, label: "27100 ΗΛΕΙΑΣ ΠΥΡΓΟΣ ΗΛΕΙΑΣ" },
  { value: 27131, label: "27131 ΗΛΕΙΑΣ ΠΥΡΓΟΣ ΗΛΕΙΑΣ" },
  { value: 27200, label: "27200 ΗΛΕΙΑΣ ΑΜΑΛΙΑΔΑ" },
  { value: 27300, label: "27300 ΗΛΕΙΑΣ ΓΑΣΤΟΥΝΗ" },
  { value: 28080, label: "28080 ΚΕΦΑΛΛΗΝΙΑΣ ΣΑΜΗ" },
  { value: 28081, label: "28081 ΚΕΦΑΛΛΗΝΙΑΣ ΑΓΙΑ ΕΥΦΗΜΙΑ" },
  { value: 28082, label: "28082 ΚΕΦΑΛΛΗΝΙΑΣ ΧΙΟΝΑΤΑ" },
  { value: 28083, label: "28083 ΚΕΦΑΛΛΗΝΙΑΣ ΚΕΡΑΜΕΙΕΣ" },
  { value: 28084, label: "28084 ΚΕΦΑΛΛΗΝΙΑΣ ΦΙΣΚΑΡΔΟ" },
  { value: 28085, label: "28085 ΚΕΦΑΛΛΗΝΙΑΣ ΒΑΣΙΛΙΚΙΑΔΕΣ" },
  { value: 28086, label: "28086 ΚΕΦΑΛΛΗΝΙΑΣ ΠΟΡΟΣ" },
  { value: 28100, label: "28100 ΚΕΦΑΛΛΗΝΙΑΣ ΑΡΓΟΣΤΟΛΙ" },
  { value: 28200, label: "28200 ΚΕΦΑΛΛΗΝΙΑΣ ΛΗΞΟΥΡΙ" },
  { value: 28300, label: "28300 ΚΕΦΑΛΛΗΝΙΑΣ ΙΘΑΚΗ" },
  { value: 28301, label: "28301 ΚΕΦΑΛΛΗΝΙΑΣ ΣΤΑΥΡΟΣ ΙΘΑΚΗΣ" },
  { value: 29090, label: "29090 ΖΑΚΥΝΘΟΥ ΚΑΤΑΣΤΑΡΙ" },
  { value: 29091, label: "29091 ΖΑΚΥΝΘΟΥ ΒΟΛΙΜΕΣ" },
  { value: 29092, label: "29092 ΖΑΚΥΝΘΟΥ ΜΑΧΑΙΡΑΔΟ" },
  { value: 29100, label: "29100 ΖΑΚΥΝΘΟΥ ΖΑΚΥΝΘΟΣ" },
  { value: 30001, label: "30001 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΝΕΟΧΩΡΙ ΑΙΤΩΛ.ΝΙΑΣ" },
  { value: 30002, label: "30002 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΒΟΝΙΤΣΑ" },
  { value: 30003, label: "30003 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΠΑΝΑΙΤΩΛΙΟ" },
  { value: 30004, label: "30004 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΚΑΤΟΥΝΑ" },
  { value: 30005, label: "30005 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΚΑΙΝΟΥΡΓΙΟ" },
  { value: 30006, label: "30006 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΑΣΤΑΚΟΣ" },
  { value: 30007, label: "30007 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΚΑΤΟΧΗ" },
  { value: 30008, label: "30008 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΘΕΡΜΟ" },
  { value: 30009, label: "30009 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΦΥΤΕΙΕΣ" },
  { value: 30010, label: "30010 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΠΑΡΑΒΟΛΑ" },
  { value: 30011, label: "30011 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΜΑΤΑΡΑΓΚΑ" },
  { value: 30012, label: "30012 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΠΑΛΑΙΡΟΣ" },
  { value: 30013, label: "30013 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΜΟΝΑΣΤΗΡΑΚΙ" },
  { value: 30014, label: "30014 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΕΥΗΝΟΧΩΡΙ" },
  { value: 30015, label: "30015 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΓΑΒΑΛΟΥ" },
  { value: 30016, label: "30016 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΜΕΝΙΔΙ" },
  { value: 30017, label: "30017 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΕΜΠΕΣΟΣ" },
  { value: 30018, label: "30018 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΑΜΟΡΓΙΑΝΟΙ" },
  { value: 30019, label: "30019 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΜΥΤΙΚΑΣ" },
  { value: 30020, label: "30020 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΑΝΤΙΡΡΙΟ" },
  { value: 30021, label: "30021 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΑΓΙΟΣ ΒΛΑΣΙΟΣ" },
  { value: 30022, label: "30022 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΠΛΑΤΑΝΟΣ" },
  { value: 30023, label: "30023 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΑΝΩ ΧΩΡΑ" },
  { value: 30024, label: "30024 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΤΕΡΨΙΘΕΑ" },
  { value: 30025, label: "30025 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΚΛΕΠΑ" },
  { value: 30026, label: "30026 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΣΙΜΟΣ" },
  { value: 30027, label: "30027 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΑΓΙΟΣ ΚΩΝΣΤΑΝΤΙΝΟΣ" },
  { value: 30100, label: "30100 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΑΓΡΙΝΙΟ" },
  { value: 30131, label: "30131 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΑΓΡΙΝΙΟ" },
  { value: 30132, label: "30132 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΑΓΡΙΝΙΟ" },
  { value: 30133, label: "30133 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΑΓΡΙΝΙΟ" },
  { value: 30134, label: "30134 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΑΓΡΙΝΙΟ" },
  { value: 30200, label: "30200 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΜΕΣΟΛΟΓΓΙ" },
  { value: 30214, label: "30214 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΕΥΗΝΟΧΩΡΙ" },
  { value: 30300, label: "30300 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΝΑΥΠΑΚΤΟΣ" },
  { value: 30400, label: "30400 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΑΙΤΩΛΙΚΟ" },
  { value: 30500, label: "30500 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΑΜΦΙΛΟΧΙΑ" },
  { value: 31080, label: "31080 ΛΕΥΚΑΔΑΣ ΚΑΡΥΑ" },
  { value: 31081, label: "31081 ΛΕΥΚΑΔΑΣ ΚΑΛΑΜΟΣ" },
  { value: 31082, label: "31082 ΛΕΥΚΑΔΑΣ ΒΑΣΙΛΙΚΗ" },
  { value: 31083, label: "31083 ΛΕΥΚΑΔΑΣ ΒΑΘΥ" },
  { value: 31100, label: "31100 ΛΕΥΚΑΔΑΣ ΛΕΥΚΑΔΑ" },
  { value: 32001, label: "32001 ΒΟΙΩΤΙΑΣ ΑΛΙΑΡΤΟΣ" },
  { value: 32002, label: "32002 ΒΟΙΩΤΙΑΣ ΒΑΓΙΑ" },
  { value: 32003, label: "32003 ΒΟΙΩΤΙΑΣ ΠΑΡΑΛΙΑ ΔΙΣΤΟΜΟΥ" },
  { value: 32004, label: "32004 ΒΟΙΩΤΙΑΣ ΑΡΑΧΩΒΑ" },
  { value: 32005, label: "32005 ΒΟΙΩΤΙΑΣ ΔΙΣΤΟΜΟ" },
  { value: 32006, label: "32006 ΒΟΙΩΤΙΑΣ ΚΥΡΙΑΚΙ" },
  { value: 32007, label: "32007 ΒΟΙΩΤΙΑΣ ΑΓΙΟΣ ΓΕΩΡΓΙΟΣ ΒΟΙΩΤ" },
  { value: 32008, label: "32008 ΒΟΙΩΤΙΑΣ ΔΑΥΛΕΙΑ" },
  { value: 32009, label: "32009 ΒΟΙΩΤΙΑΣ ΣΧΗΜΑΤΑΡΙ" },
  { value: 32010, label: "32010 ΒΟΙΩΤΙΑΣ ΔΟΜΒΡΑΙΝΑ" },
  { value: 32011, label: "32011 ΒΟΙΩΤΙΑΣ ΟΙΝΟΦΥΤΑ" },
  { value: 32012, label: "32012 ΒΟΙΩΤΙΑΣ ΑΝΤΙΚΥΡΑ" },
  { value: 32100, label: "32100 ΒΟΙΩΤΙΑΣ ΛΙΒΑΔΕΙΑ" },
  { value: 32131, label: "32131 ΒΟΙΩΤΙΑΣ ΛΙΒΑΔΕΙΑ" },
  { value: 32200, label: "32200 ΒΟΙΩΤΙΑΣ ΘΗΒΑ" },
  { value: 32300, label: "32300 ΒΟΙΩΤΙΑΣ ΟΡΧΟΜΕΝΟΣ" },
  { value: 33050, label: "33050 ΦΩΚΙΔΑΣ ΔΕΣΦΙΝΑ" },
  { value: 33051, label: "33051 ΦΩΚΙΔΑΣ ΠΟΛΥΔΡΟΣΟΣ" },
  { value: 33052, label: "33052 ΦΩΚΙΔΑΣ ΓΑΛΑΞΙΔΙ" },
  { value: 33053, label: "33053 ΦΩΚΙΔΑΣ ΛΙΔΟΡΙΚΙ" },
  { value: 33054, label: "33054 ΦΩΚΙΔΑΣ ΔΕΛΦΟΙ" },
  { value: 33055, label: "33055 ΦΩΚΙΔΑΣ ΧΡΥΣΟ ΦΩΚΙΔΑΣ" },
  { value: 33056, label: "33056 ΦΩΚΙΔΑΣ ΕΥΠΑΛΙΟ" },
  { value: 33057, label: "33057 ΦΩΚΙΔΑΣ ΓΡΑΒΙΑ" },
  { value: 33058, label: "33058 ΦΩΚΙΔΑΣ ΕΡΑΤΕΙΝΗ" },
  { value: 33059, label: "33059 ΦΩΚΙΔΑΣ ΑΡΤΟΤΙΝΑ" },
  { value: 33060, label: "33060 ΦΩΚΙΔΑΣ ΠΟΤΙΔΑΝΙΑ" },
  { value: 33061, label: "33061 ΦΩΚΙΔΑΣ ΚΡΟΚΥΛΕΙΟ" },
  { value: 33062, label: "33062 ΦΩΚΙΔΑΣ ΠΕΝΤΑΓΙΟΙ" },
  { value: 33063, label: "33063 ΦΩΚΙΔΑΣ ΜΑΥΡΟΛΙΘΑΡΙ" },
  { value: 33100, label: "33100 ΦΩΚΙΔΑΣ ΑΜΦΙΣΣΑ" },
  { value: 33200, label: "33200 ΦΩΚΙΔΑΣ ΙΤΕΑ ΦΩΚΙΔΑΣ" },
  { value: 34001, label: "34001 ΕΥΒΟΙΑΣ ΚΑΡΥΣΤΟΣ" },
  { value: 34002, label: "34002 ΕΥΒΟΙΑΣ ΒΑΣΙΛΙΚΟ" },
  { value: 34003, label: "34003 ΕΥΒΟΙΑΣ ΚΥΜΗ" },
  { value: 34004, label: "34004 ΕΥΒΟΙΑΣ ΜΑΝΤΟΥΔΙ" },
  { value: 34005, label: "34005 ΕΥΒΟΙΑΣ ΛΙΜΝΗ" },
  { value: 34006, label: "34006 ΕΥΒΟΙΑΣ ΑΜΑΡΥΝΘΟΣ" },
  { value: 34007, label: "34007 ΕΥΒΟΙΑΣ ΣΚΥΡΟΣ" },
  { value: 34008, label: "34008 ΕΥΒΟΙΑΣ ΕΡΕΤΡΙΑ" },
  { value: 34009, label: "34009 ΕΥΒΟΙΑΣ ΑΥΛΩΝΑΡΙ" },
  { value: 34010, label: "34010 ΕΥΒΟΙΑΣ ΑΓΙΑ ΑΝΝΑ" },
  { value: 34011, label: "34011 ΕΥΒΟΙΑΣ ΟΞΥΛΙΘΟΣ" },
  { value: 34012, label: "34012 ΕΥΒΟΙΑΣ ΩΡΑΙΟΥΣ" },
  { value: 34013, label: "34013 ΕΥΒΟΙΑΣ ΜΑΡΜΑΡΙ" },
  { value: 34014, label: "34014 ΕΥΒΟΙΑΣ ΣΤΕΝΗ ΔΙΡΦΥΟΣ" },
  { value: 34015, label: "34015 ΕΥΒΟΙΑΣ ΣΤΥΡΑ" },
  { value: 34016, label: "34016 ΕΥΒΟΙΑΣ ΚΟΝΙΣΤΡΕΣ" },
  { value: 34017, label: "34017 ΕΥΒΟΙΑΣ ΚΡΙΕΖΑ" },
  { value: 34018, label: "34018 ΕΥΒΟΙΑΣ ΚΑΘΕΝΟΙ" },
  { value: 34019, label: "34019 ΕΥΒΟΙΑΣ ΚΑΛΗΜΕΡΙΑΝΟΙ" },
  { value: 34100, label: "34100 ΕΥΒΟΙΑΣ ΧΑΛΚΙΔΑ" },
  { value: 34131, label: "34131 ΕΥΒΟΙΑΣ ΧΑΛΚΙΔΑ" },
  { value: 34131, label: "34131 ΕΥΒΟΙΑΣ ΧΑΛΚΙΔΑ" },
  { value: 34132, label: "34132 ΕΥΒΟΙΑΣ ΧΑΛΚΙΔΑ" },
  { value: 34132, label: "34132 ΕΥΒΟΙΑΣ ΧΑΛΚΙΔΑ" },
  { value: 34133, label: "34133 ΕΥΒΟΙΑΣ ΧΑΛΚΙΔΑ" },
  { value: 34133, label: "34133 ΕΥΒΟΙΑΣ ΧΑΛΚΙΔΑ" },
  { value: 34200, label: "34200 ΕΥΒΟΙΑΣ ΙΣΤΙΑΙΑ" },
  { value: 34300, label: "34300 ΕΥΒΟΙΑΣ ΛΟΥΤΡΑ ΑΙΔΗΨΟΥ" },
  { value: 34400, label: "34400 ΕΥΒΟΙΑΣ ΨΑΧΝΑ" },
  { value: 34500, label: "34500 ΕΥΒΟΙΑΣ ΑΛΙΒΕΡΙ" },
  { value: 34600, label: "34600 ΕΥΒΟΙΑΣ ΝΕΑ ΑΡΤΑΚΗ" },
  { value: 35001, label: "35001 ΦΘΙΩΤΙΔΑΣ ΜΑΛΕΣΙΝΑ" },
  { value: 35002, label: "35002 ΦΘΙΩΤΙΔΑΣ ΑΜΦΙΚΛΕΙΑ" },
  { value: 35003, label: "35003 ΦΘΙΩΤΙΔΑΣ ΣΠΕΡΧΕΙΑΔΑ" },
  { value: 35004, label: "35004 ΦΘΙΩΤΙΔΑΣ ΕΛΑΤΕΙΑ" },
  { value: 35005, label: "35005 ΦΘΙΩΤΙΔΑΣ ΜΑΡΤΙΝΟ" },
  { value: 35006, label: "35006 ΦΘΙΩΤΙΔΑΣ ΑΓΙΟΣ ΚΩΝΣΤΑΝΤΙΝΟΣ" },
  { value: 35007, label: "35007 ΦΘΙΩΤΙΔΑΣ ΛΙΒΑΝΑΤΕΣ" },
  { value: 35008, label: "35008 ΦΘΙΩΤΙΔΑΣ ΚΑΜΜΕΝΑ ΒΟΥΡΛΑ" },
  { value: 35009, label: "35009 ΦΘΙΩΤΙΔΑΣ ΜΩΛΟΣ" },
  { value: 35010, label: "35010 ΦΘΙΩΤΙΔΑΣ ΔΟΜΟΚΟΣ" },
  { value: 35011, label: "35011 ΦΘΙΩΤΙΔΑΣ ΜΑΚΡΑΚΩΜΗ" },
  { value: 35012, label: "35012 ΦΘΙΩΤΙΔΑΣ ΛΑΡΥΜΝΑ" },
  { value: 35013, label: "35013 ΦΘΙΩΤΙΔΑΣ ΠΕΛΑΣΓΙΑ" },
  { value: 35014, label: "35014 ΦΘΙΩΤΙΔΑΣ ΑΝΘΗΛΗ" },
  { value: 35015, label: "35015 ΦΘΙΩΤΙΔΑΣ ΚΑΤΩ ΤΙΘΟΡΕΑ" },
  { value: 35016, label: "35016 ΦΘΙΩΤΙΔΑΣ ΥΠΑΤΗ" },
  { value: 35017, label: "35017 ΦΘΙΩΤΙΔΑΣ ΑΓΙΟΣ ΓΕΩΡΓΙΟΣ ΦΘΙΩΤ" },
  { value: 35018, label: "35018 ΦΘΙΩΤΙΔΑΣ ΓΑΡΔΙΚΙ" },
  { value: 35100, label: "35100 ΦΘΙΩΤΙΔΑΣ ΛΑΜΙΑ" },
  { value: 35131, label: "35131 ΦΘΙΩΤΙΔΑΣ ΛΑΜΙΑ" },
  { value: 35132, label: "35132 ΦΘΙΩΤΙΔΑΣ ΛΑΜΙΑ" },
  { value: 35133, label: "35133 ΦΘΙΩΤΙΔΑΣ ΛΑΜΙΑ" },
  { value: 35200, label: "35200 ΦΘΙΩΤΙΔΑΣ ΑΤΑΛΑΝΤΗ" },
  { value: 35300, label: "35300 ΦΘΙΩΤΙΔΑΣ ΣΤΥΛΙΔΑ" },
  { value: 36070, label: "36070 ΕΥΡΥΤΑΝΙΑΣ ΡΑΠΤΟΠΟΥΛΟ" },
  { value: 36071, label: "36071 ΕΥΡΥΤΑΝΙΑΣ ΚΕΡΑΣΟΧΩΡΙ" },
  { value: 36072, label: "36072 ΕΥΡΥΤΑΝΙΑΣ ΓΡΑΝΙΤΣΑ" },
  { value: 36073, label: "36073 ΕΥΡΥΤΑΝΙΑΣ ΑΓΡΑΦΑ" },
  { value: 36074, label: "36074 ΕΥΡΥΤΑΝΙΑΣ ΠΡΟΥΣΟΣ" },
  { value: 36075, label: "36075 ΕΥΡΥΤΑΝΙΑΣ ΜΕΓΑΛΟ ΧΩΡΙΟ" },
  { value: 36076, label: "36076 ΕΥΡΥΤΑΝΙΑΣ ΚΡΙΚΕΛΛΟ" },
  { value: 36080, label: "36080 ΕΥΡΥΤΑΝΙΑΣ ΦΟΥΡΝΑ" },
  { value: 36081, label: "36081 ΕΥΡΥΤΑΝΙΑΣ ΑΓΙΑ ΤΡΙΑΔΑ ΕΥΡΥΤ." },
  { value: 36100, label: "36100 ΕΥΡΥΤΑΝΙΑΣ ΚΑΡΠΕΝΗΣΙ" },
  { value: 37001, label: "37001 ΜΑΓΝΗΣΙΑΣ ΖΑΓΟΡΑ" },
  { value: 37002, label: "37002 ΜΑΓΝΗΣΙΑΣ ΣΚΙΑΘΟΣ" },
  { value: 37003, label: "37003 ΜΑΓΝΗΣΙΑΣ ΣΚΟΠΕΛΟΣ" },
  { value: 37004, label: "37004 ΜΑΓΝΗΣΙΑΣ ΓΛΩΣΣΑ" },
  { value: 37005, label: "37005 ΜΑΓΝΗΣΙΑΣ ΑΛΟΝΝΗΣΟΣ" },
  { value: 37006, label: "37006 ΜΑΓΝΗΣΙΑΣ ΑΡΓΑΛΑΣΤΗ" },
  { value: 37007, label: "37007 ΜΑΓΝΗΣΙΑΣ ΠΤΕΛΕΟΣ" },
  { value: 37008, label: "37008 ΜΑΓΝΗΣΙΑΣ ΣΟΥΡΠΗ" },
  { value: 37009, label: "37009 ΜΑΓΝΗΣΙΑΣ ΤΡΙΚΕΡΙ" },
  { value: 37010, label: "37010 ΜΑΓΝΗΣΙΑΣ ΜΗΛΙΕΣ" },
  { value: 37011, label: "37011 ΜΑΓΝΗΣΙΑΣ ΠΟΡΤΑΡΙΑ" },
  { value: 37012, label: "37012 ΜΑΓΝΗΣΙΑΣ ΤΣΑΓΚΑΡΑΔΑ" },
  { value: 37013, label: "37013 ΜΑΓΝΗΣΙΑΣ ΜΗΛΙΝΑ" },
  { value: 37100, label: "37100 ΜΑΓΝΗΣΙΑΣ ΑΛΜΥΡΟΣ" },
  { value: 37200, label: "37200 ΜΑΓΝΗΣΙΑΣ ΑΓΙΟΣ ΓΕΩΡΓΙΟΣ ΙΩΛΚΟ" },
  { value: 37300, label: "37300 ΜΑΓΝΗΣΙΑΣ ΑΓΡΙΑ" },
  { value: 37400, label: "37400 ΜΑΓΝΗΣΙΑΣ ΝΕΑ ΑΓΧΙΑΛΟΣ" },
  { value: 37500, label: "37500 ΜΑΓΝΗΣΙΑΣ ΒΕΛΕΣΤΙΝΟ" },
  { value: 38221, label: "38221 ΜΑΓΝΗΣΙΑΣ ΒΟΛΟΣ" },
  { value: 38222, label: "38222 ΜΑΓΝΗΣΙΑΣ ΒΟΛΟΣ" },
  { value: 38300, label: "38300 ΜΑΓΝΗΣΙΑΣ ΒΟΛΟΣ" },
  { value: 38322, label: "38322 ΜΑΓΝΗΣΙΑΣ ΒΟΛΟΣ" },
  { value: 38331, label: "38331 ΜΑΓΝΗΣΙΑΣ ΒΟΛΟΣ" },
  { value: 38333, label: "38333 ΜΑΓΝΗΣΙΑΣ ΒΟΛΟΣ" },
  { value: 38334, label: "38334 ΜΑΓΝΗΣΙΑΣ ΒΟΛΟΣ" },
  { value: 38445, label: "38445 ΜΑΓΝΗΣΙΑΣ ΝΕΑ ΙΩΝΙΑ ΒΟΛΟΣ" },
  { value: 38446, label: "38446 ΜΑΓΝΗΣΙΑΣ ΝΕΑ ΙΩΝΙΑ ΒΟΛΟΣ" },
  { value: 38500, label: "38500 ΜΑΓΝΗΣΙΑΣ ΒΟΛΟΣ" },
  { value: 40001, label: "40001 ΛΑΡΙΣΑΣ ΚΡΑΝΕΑ" },
  { value: 40002, label: "40002 ΛΑΡΙΣΑΣ ΛΙΒΑΔΙ" },
  { value: 40003, label: "40003 ΛΑΡΙΣΑΣ ΑΓΙΑ" },
  { value: 40004, label: "40004 ΛΑΡΙΣΑΣ ΓΟΝΝΟΙ" },
  { value: 40005, label: "40005 ΛΑΡΙΣΑΣ ΒΕΡΔΙΚΟΥΣΙΑ" },
  { value: 40006, label: "40006 ΛΑΡΙΣΑΣ ΣΥΚΟΥΡΙ" },
  { value: 40007, label: "40007 ΛΑΡΙΣΑΣ ΠΥΡΓΕΤΟΣ" },
  { value: 40008, label: "40008 ΛΑΡΙΣΑΣ ΡΑΨΑΝΗ" },
  { value: 40009, label: "40009 ΛΑΡΙΣΑΣ ΠΛΑΤΥΚΑΜΠΟΣ" },
  { value: 40010, label: "40010 ΛΑΡΙΣΑΣ ΤΣΑΡΙΤΣΑΝΗ" },
  { value: 40011, label: "40011 ΛΑΡΙΣΑΣ ΦΑΛΑΝΗ" },
  { value: 40100, label: "40100 ΛΑΡΙΣΑΣ ΤΥΡΝΑΒΟΣ" },
  { value: 40200, label: "40200 ΛΑΡΙΣΑΣ ΕΛΑΣΣΟΝΑ" },
  { value: 40300, label: "40300 ΛΑΡΙΣΑΣ ΦΑΡΣΑΛΑ" },
  { value: 40400, label: "40400 ΛΑΡΙΣΑΣ ΑΜΠΕΛΩΝΑΣ" },
  { value: 41001, label: "41001 ΛΑΡΙΣΑΣ ΛΑΡΙΣΑ" },
  { value: 41221, label: "41221 ΛΑΡΙΣΑΣ ΛΑΡΙΣΑ" },
  { value: 41222, label: "41222 ΛΑΡΙΣΑΣ ΛΑΡΙΣΑ" },
  { value: 41223, label: "41223 ΛΑΡΙΣΑΣ ΛΑΡΙΣΑ" },
  { value: 41334, label: "41334 ΛΑΡΙΣΑΣ ΛΑΡΙΣΑ" },
  { value: 41335, label: "41335 ΛΑΡΙΣΑΣ ΛΑΡΙΣΑ" },
  { value: 41336, label: "41336 ΛΑΡΙΣΑΣ ΛΑΡΙΣΑ" },
  { value: 41447, label: "41447 ΛΑΡΙΣΑΣ ΛΑΡΙΣΑ" },
  { value: 41500, label: "41500 ΛΑΡΙΣΑΣ ΛΑΡΙΣΑ" },
  { value: 42030, label: "42030 ΤΡΙΚΑΛΩΝ ΜΕΓΑΛΑ ΚΑΛΥΒΙΑ" },
  { value: 42031, label: "42031 ΤΡΙΚΑΛΩΝ ΦΑΡΚΑΔΩΝΑ" },
  { value: 42032, label: "42032 ΤΡΙΚΑΛΩΝ ΠΥΛΗ" },
  { value: 42033, label: "42033 ΤΡΙΚΑΛΩΝ ΜΥΡΟΦΥΛΛΟ" },
  { value: 42034, label: "42034 ΤΡΙΚΑΛΩΝ ΑΓΙΟΦΥΛΛΟ" },
  { value: 42035, label: "42035 ΤΡΙΚΑΛΩΝ ΚΟΝΙΣΚΟΣ" },
  { value: 42036, label: "42036 ΤΡΙΚΑΛΩΝ ΚΑΣΤΑΝΕΑ" },
  { value: 42037, label: "42037 ΤΡΙΚΑΛΩΝ ΜΕΣΟΧΩΡΑ" },
  { value: 42100, label: "42100 ΤΡΙΚΑΛΩΝ ΤΡΙΚΑΛΑ" },
  { value: 42131, label: "42131 ΤΡΙΚΑΛΩΝ ΤΡΙΚΑΛΑ" },
  { value: 42132, label: "42132 ΤΡΙΚΑΛΩΝ ΤΡΙΚΑΛΑ" },
  { value: 42200, label: "42200 ΤΡΙΚΑΛΩΝ ΚΑΛΑΜΠΑΚΑ" },
  { value: 42300, label: "42300 ΤΡΙΚΑΛΩΝ ΝΕΟΧΩΡΙ" },
  { value: 43060, label: "43060 ΚΑΡΔΙΤΣΑΣ ΜΟΥΖΑΚΙ" },
  { value: 43061, label: "43061 ΚΑΡΔΙΤΣΑΣ ΑΓΝΑΝΤΕΡΟ" },
  { value: 43062, label: "43062 ΚΑΡΔΙΤΣΑΣ ΙΤΕΑ ΚΑΡΔΙΤΣΑΣ" },
  { value: 43063, label: "43063 ΚΑΡΔΙΤΣΑΣ ΛΕΟΝΤΑΡΙ ΚΑΡΔΙΤΣΑΣ" },
  { value: 43064, label: "43064 ΚΑΡΔΙΤΣΑΣ ΦΑΝΑΡΙ" },
  { value: 43065, label: "43065 ΚΑΡΔΙΤΣΑΣ ΑΝΘΗΡΟ" },
  { value: 43066, label: "43066 ΚΑΡΔΙΤΣΑΣ ΒΡΑΓΚΙΑΝΑ" },
  { value: 43067, label: "43067 ΚΑΡΔΙΤΣΑΣ ΜΕΣΕΝΙΚΟΛΑΣ" },
  { value: 43068, label: "43068 ΚΑΡΔΙΤΣΑΣ ΡΕΝΤΙΝΑ" },
  { value: 43069, label: "43069 ΚΑΡΔΙΤΣΑΣ ΠΕΤΡΙΛΟ" },
  { value: 43070, label: "43070 ΚΑΡΔΙΤΣΑΣ ΠΡΟΑΣΤΙΟ" },
  { value: 43100, label: "43100 ΚΑΡΔΙΤΣΑΣ ΚΑΡΔΙΤΣΑ" },
  { value: 43131, label: "43131 ΚΑΡΔΙΤΣΑΣ ΚΑΡΔΙΤΣΑ" },
  { value: 43132, label: "43132 ΚΑΡΔΙΤΣΑΣ ΚΑΡΔΙΤΣΑ" },
  { value: 43200, label: "43200 ΚΑΡΔΙΤΣΑΣ ΠΑΛΑΜΑΣ" },
  { value: 43300, label: "43300 ΚΑΡΔΙΤΣΑΣ ΣΟΦΑΔΕΣ" },
  { value: 44001, label: "44001 ΙΩΑΝΝΙΝΩΝ ΠΡΑΜΑΝΤΑ" },
  { value: 44002, label: "44002 ΙΩΑΝΝΙΝΩΝ ΔΕΛΒΙΝΑΚΙ" },
  { value: 44003, label: "44003 ΙΩΑΝΝΙΝΩΝ ΖΙΤΣΑ" },
  { value: 44004, label: "44004 ΙΩΑΝΝΙΝΩΝ ΔΟΛΙΑΝΑ" },
  { value: 44005, label: "44005 ΙΩΑΝΝΙΝΩΝ ΠΩΓΩΝΙΑΝΗ" },
  { value: 44006, label: "44006 ΙΩΑΝΝΙΝΩΝ ΚΕΦΑΛΟΒΡΥΣΟ" },
  { value: 44007, label: "44007 ΙΩΑΝΝΙΝΩΝ ΑΣΠΡΑΓΓΕΛΟΙ" },
  { value: 44008, label: "44008 ΙΩΑΝΝΙΝΩΝ ΑΓΙΑ ΠΑΡΑΣΚΕΥΗ ΙΩΑΝ." },
  { value: 44009, label: "44009 ΙΩΑΝΝΙΝΩΝ ΔΕΡΒΙΖΙΑΝΑ" },
  { value: 44010, label: "44010 ΙΩΑΝΝΙΝΩΝ ΤΣΕΠΕΛΟΒΟ" },
  { value: 44012, label: "44012 ΙΩΑΝΝΙΝΩΝ ΒΗΣΣΑΝΗ" },
  { value: 44013, label: "44013 ΙΩΑΝΝΙΝΩΝ ΚΑΛΕΝΤΖΙ" },
  { value: 44014, label: "44014 ΙΩΑΝΝΙΝΩΝ ΓΡΕΒΕΝΙΤΙΟ" },
  { value: 44015, label: "44015 ΙΩΑΝΝΙΝΩΝ ΠΥΡΣΟΓΙΑΝΝΗ" },
  { value: 44016, label: "44016 ΙΩΑΝΝΙΝΩΝ ΑΡΙΣΤΗ" },
  { value: 44017, label: "44017 ΙΩΑΝΝΙΝΩΝ ΒΡΟΣΙΝΑ" },
  { value: 44018, label: "44018 ΙΩΑΝΝΙΝΩΝ ΚΗΠΟΙ" },
  { value: 44019, label: "44019 ΙΩΑΝΝΙΝΩΝ ΠΑΛΑΙΟΣΕΛΙ" },
  { value: 44020, label: "44020 ΙΩΑΝΝΙΝΩΝ ΜΟΛΙΣΤΑ" },
  { value: 44100, label: "44100 ΙΩΑΝΝΙΝΩΝ ΚΟΝΙΤΣΑ" },
  { value: 44200, label: "44200 ΙΩΑΝΝΙΝΩΝ ΜΕΤΣΟΒΟ" },
  { value: 45221, label: "45221 ΙΩΑΝΝΙΝΩΝ ΙΩΑΝΝΙΝΑ" },
  { value: 45232, label: "45232 ΙΩΑΝΝΙΝΩΝ ΙΩΑΝΝΙΝΑ" },
  { value: 45332, label: "45332 ΙΩΑΝΝΙΝΩΝ ΙΩΑΝΝΙΝΑ" },
  { value: 45333, label: "45333 ΙΩΑΝΝΙΝΩΝ ΙΩΑΝΝΙΝΑ" },
  { value: 45442, label: "45442 ΙΩΑΝΝΙΝΩΝ ΙΩΑΝΝΙΝΑ" },
  { value: 45444, label: "45444 ΙΩΑΝΝΙΝΩΝ ΙΩΑΝΝΙΝΑ" },
  { value: 45445, label: "45445 ΙΩΑΝΝΙΝΩΝ ΙΩΑΝΝΙΝΑ" },
  { value: 45500, label: "45500 ΙΩΑΝΝΙΝΩΝ ΙΩΑΝΝΙΝΑ" },
  { value: 46030, label: "46030 ΘΕΣΠΡΩΤΙΑΣ ΜΑΡΓΑΡΙΤΙ" },
  { value: 46031, label: "46031 ΘΕΣΠΡΩΤΙΑΣ ΓΛΥΚΗ" },
  { value: 46032, label: "46032 ΘΕΣΠΡΩΤΙΑΣ ΑΓΙΟΙ ΠΑΝΤΕΣ" },
  { value: 46033, label: "46033 ΘΕΣΠΡΩΤΙΑΣ ΚΕΡΑΜΙΤΣΑ" },
  { value: 46100, label: "46100 ΘΕΣΠΡΩΤΙΑΣ ΗΓΟΥΜΕΝΙΤΣΑ" },
  { value: 46200, label: "46200 ΘΕΣΠΡΩΤΙΑΣ ΠΑΡΑΜΥΘΙΑ" },
  { value: 46300, label: "46300 ΘΕΣΠΡΩΤΙΑΣ ΦΙΛΙΑΤΕΣ" },
  { value: 47040, label: "47040 ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ ΚΟΜΠΟΤΙ" },
  { value: 47041, label: "47041 ΑΡΤΑΣ ΝΕΟΧΩΡΙ ΑΡΤΑΣ" },
  { value: 47042, label: "47042 ΑΡΤΑΣ ΦΙΛΟΘΕΗ" },
  { value: 47043, label: "47043 ΑΡΤΑΣ ΑΓΝΑΝΤΑ" },
  { value: 47044, label: "47044 ΑΡΤΑΣ ΑΝΩ ΚΑΛΕΝΤΙΝΗ" },
  { value: 47045, label: "47045 ΑΡΤΑΣ ΒΟΥΡΓΑΡΕΛΙ" },
  { value: 47046, label: "47046 ΑΡΤΑΣ ΡΟΔΑΥΓΗ" },
  { value: 47047, label: "47047 ΑΡΤΑΣ ΜΗΛΙΑΝΑ" },
  { value: 47048, label: "47048 ΑΡΤΑΣ ΔΗΜΑΡΙ" },
  { value: 47100, label: "47100 ΑΡΤΑΣ ΑΡΤΑ" },
  { value: 47131, label: "47131 ΑΡΤΑΣ ΑΡΤΑ" },
  { value: 47132, label: "47132 ΑΡΤΑΣ ΑΡΤΑ" },
  { value: 47200, label: "47200 ΑΡΤΑΣ ΠΕΤΑ" },
  { value: 48060, label: "48060 ΠΡΕΒΕΖΑΣ ΠΑΡΓΑ" },
  { value: 48061, label: "48061 ΠΡΕΒΕΖΑΣ ΛΟΥΡΟΣ" },
  { value: 48062, label: "48062 ΠΡΕΒΕΖΑΣ ΚΑΝΑΛΛΑΚΙ" },
  { value: 48100, label: "48100 ΠΡΕΒΕΖΑΣ ΠΡΕΒΕΖΑ" },
  { value: 48200, label: "48200 ΠΡΕΒΕΖΑΣ ΦΙΛΙΠΠΙΑΔΑ" },
  { value: 48300, label: "48300 ΠΡΕΒΕΖΑΣ ΘΕΣΠΡΩΤΙΚΟ" },
  { value: 49080, label: "49080 ΚΕΡΚΥΡΑΣ ΛΕΥΚΙΜΜΗ" },
  { value: 49081, label: "49081 ΚΕΡΚΥΡΑΣ ΚΑΡΟΥΣΑΔΕΣ" },
  { value: 49082, label: "49082 ΚΕΡΚΥΡΑΣ ΓΑΙΟΣ" },
  { value: 49083, label: "49083 ΚΕΡΚΥΡΑΣ ΣΚΡΙΠΕΡΟ" },
  { value: 49084, label: "49084 ΚΕΡΚΥΡΑΣ ΚΑΣΤΕΛΛΑΝΟΙ ΜΕΣΗΣ" },
  { value: 49100, label: "49100 ΚΕΡΚΥΡΑΣ ΚΕΡΚΥΡΑ" },
  { value: 49131, label: "49131 ΚΕΡΚΥΡΑΣ ΚΕΡΚΥΡΑ" },
  { value: 49132, label: "49132 ΚΕΡΚΥΡΑΣ ΚΕΡΚΥΡΑ" },
  { value: 50001, label: "50001 ΚΟΖΑΝΗΣ ΝΕΑΠΟΛΗ" },
  { value: 50002, label: "50002 ΚΟΖΑΝΗΣ ΤΣΟΤΙΛΙ" },
  { value: 50003, label: "50003 ΚΟΖΑΝΗΣ ΕΡΑΤΥΡΑ" },
  { value: 50004, label: "50004 ΚΟΖΑΝΗΣ ΑΙΑΝΗ" },
  { value: 50005, label: "50005 ΚΟΖΑΝΗΣ ΕΜΠΟΡΙΟ" },
  { value: 50006, label: "50006 ΚΟΖΑΝΗΣ ΠΥΡΓΟΙ" },
  { value: 50007, label: "50007 ΚΟΖΑΝΗΣ ΠΕΝΤΑΛΟΦΟΣ" },
  { value: 50008, label: "50008 ΚΟΖΑΝΗΣ ΑΥΓΕΡΙΝΟΣ" },
  { value: 50009, label: "50009 ΚΟΖΑΝΗΣ ΒΛΑΣΤΗ" },
  { value: 50010, label: "50010 ΚΟΖΑΝΗΣ ΚΡΟΚΟΣ" },
  { value: 50100, label: "50100 ΚΟΖΑΝΗΣ ΚΟΖΑΝΗ" },
  { value: 50131, label: "50131 ΚΟΖΑΝΗΣ ΚΟΖΑΝΗ" },
  { value: 50132, label: "50132 ΚΟΖΑΝΗΣ ΚΟΖΑΝΗ" },
  { value: 50200, label: "50200 ΚΟΖΑΝΗΣ ΠΤΟΛΕΜΑΙΔΑ" },
  { value: 50300, label: "50300 ΚΟΖΑΝΗΣ ΣΙΑΤΙΣΤΑ" },
  { value: 50400, label: "50400 ΚΟΖΑΝΗΣ ΒΕΛΒΕΝΤΟΣ" },
  { value: 50500, label: "50500 ΚΟΖΑΝΗΣ ΣΕΡΒΙΑ" },
  { value: 51030, label: "51030 ΓΡΕΒΕΝΩΝ ΑΓΙΟΣ ΓΕΩΡΓΙΟΣ ΓΡΕΒΕ" },
  { value: 51031, label: "51031 ΓΡΕΒΕΝΩΝ ΚΗΠΟΥΡΕΙΟ" },
  { value: 51032, label: "51032 ΓΡΕΒΕΝΩΝ ΠΟΛΥΝΕΡΙ" },
  { value: 51100, label: "51100 ΓΡΕΒΕΝΩΝ ΓΡΕΒΕΝΑ" },
  { value: 51200, label: "51200 ΓΡΕΒΕΝΩΝ ΔΕΣΚΑΤΗ" },
  { value: 52050, label: "52050 ΚΑΣΤΟΡΙΑΣ ΜΕΣΟΠΟΤΑΜΙΑ" },
  { value: 52051, label: "52051 ΚΑΣΤΟΡΙΑΣ ΝΕΣΤΟΡΙΟ" },
  { value: 52052, label: "52052 ΚΑΣΤΟΡΙΑΣ ΚΟΡΗΣΟΣ" },
  { value: 52053, label: "52053 ΚΑΣΤΟΡΙΑΣ ΒΟΓΑΤΣΙΚΟ" },
  { value: 52054, label: "52054 ΚΑΣΤΟΡΙΑΣ ΚΛΕΙΣΟΥΡΑ" },
  { value: 52055, label: "52055 ΚΑΣΤΟΡΙΑΣ ΜΑΚΡΟΧΩΡΙ" },
  { value: 52056, label: "52056 ΚΑΣΤΟΡΙΑΣ ΜΑΥΡΟΧΩΡΙ" },
  { value: 52057, label: "52057 ΚΑΣΤΟΡΙΑΣ ΔΙΣΠΗΛΙΟ" },
  { value: 52058, label: "52058 ΚΑΣΤΟΡΙΑΣ ΑΚΡΙΤΕΣ" },
  { value: 52059, label: "52059 ΚΑΣΤΟΡΙΑΣ ΒΙΤΣΙ" },
  { value: 52100, label: "52100 ΚΑΣΤΟΡΙΑΣ ΚΑΣΤΟΡΙΑ" },
  { value: 52200, label: "52200 ΚΑΣΤΟΡΙΑΣ ΑΡΓΟΣ ΟΡΕΣΤΙΚΟ" },
  { value: 53070, label: "53070 ΦΛΩΡΙΝΑΣ ΦΙΛΩΤΑΣ" },
  { value: 53071, label: "53071 ΦΛΩΡΙΝΑΣ ΜΕΛΙΤΗ" },
  { value: 53072, label: "53072 ΦΛΩΡΙΝΑΣ ΞΙΝΟ ΝΕΡΟ" },
  { value: 53073, label: "53073 ΦΛΩΡΙΝΑΣ ΛΕΧΟΒΟ" },
  { value: 53074, label: "53074 ΦΛΩΡΙΝΑΣ ΒΕΥΗ" },
  { value: 53075, label: "53075 ΦΛΩΡΙΝΑΣ ΣΚΛΗΘΡΟ" },
  { value: 53076, label: "53076 ΦΛΩΡΙΝΑΣ ΑΝΤΑΡΤΙΚΟ" },
  { value: 53077, label: "53077 ΦΛΩΡΙΝΑΣ ΑΓΙΟΣ ΓΕΡΜΑΝΟΣ" },
  { value: 53078, label: "53078 ΦΛΩΡΙΝΑΣ ΝΥΜΦΑΙΟ" },
  { value: 53100, label: "53100 ΦΛΩΡΙΝΑΣ ΦΛΩΡΙΝΑ" },
  { value: 53200, label: "53200 ΦΛΩΡΙΝΑΣ ΑΜΥΝΤΑΙΟ" },
  { value: 53438, label: "53438 ΘΕΣΣΑΛΟΝΙΚΗΣ ΑΓΙΟΣ ΠΑΥΛΟΣ 53438" },
  { value: 54248, label: "54248 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54249, label: "54249 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54250, label: "54250 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54351, label: "54351 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54352, label: "54352 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54453, label: "54453 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54454, label: "54454 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54500, label: "54500 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54621, label: "54621 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54622, label: "54622 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54623, label: "54623 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54624, label: "54624 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54625, label: "54625 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54626, label: "54626 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54627, label: "54627 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54628, label: "54628 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54629, label: "54629 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54630, label: "54630 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54631, label: "54631 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54632, label: "54632 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54633, label: "54633 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54634, label: "54634 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54635, label: "54635 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54636, label: "54636 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54638, label: "54638 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54639, label: "54639 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54640, label: "54640 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54641, label: "54641 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54642, label: "54642 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54643, label: "54643 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54644, label: "54644 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54645, label: "54645 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54646, label: "54646 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 54655, label: "54655 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΣΣΑΛΟΝΙΚΗ" },
  { value: 55131, label: "55131 ΘΕΣΣΑΛΟΝΙΚΗΣ ΚΑΛΑΜΑΡΙΑ" },
  { value: 55132, label: "55132 ΘΕΣΣΑΛΟΝΙΚΗΣ ΚΑΛΑΜΑΡΙΑ" },
  { value: 55133, label: "55133 ΘΕΣΣΑΛΟΝΙΚΗΣ ΚΑΛΑΜΑΡΙΑ" },
  { value: 55134, label: "55134 ΘΕΣΣΑΛΟΝΙΚΗΣ ΚΑΛΑΜΑΡΙΑ" },
  { value: 55236, label: "55236 ΘΕΣΣΑΛΟΝΙΚΗΣ ΠΑΝΟΡΑΜΑ" },
  { value: 55337, label: "55337 ΘΕΣΣΑΛΟΝΙΚΗΣ ΤΡΙΑΝΔΡΙΑ" },
  { value: 55438, label: "55438 ΘΕΣΣΑΛΟΝΙΚΗΣ ΑΓΙΟΣ ΠΑΥΛΟΣ 55438" },
  { value: 55535, label: "55535 ΘΕΣΣΑΛΟΝΙΚΗΣ ΠΥΛΑΙΑ" },
  { value: 56121, label: "56121 ΘΕΣΣΑΛΟΝΙΚΗΣ ΑΜΠΕΛΟΚΗΠΟΙ" },
  { value: 56122, label: "56122 ΘΕΣΣΑΛΟΝΙΚΗΣ ΜΕΝΕΜΕΝΗ" },
  { value: 56123, label: "56123 ΘΕΣΣΑΛΟΝΙΚΗΣ ΑΜΠΕΛΟΚΗΠΟΙ" },
  { value: 56224, label: "56224 ΘΕΣΣΑΛΟΝΙΚΗΣ ΕΥΟΣΜΟ" },
  { value: 56334, label: "56334 ΘΕΣΣΑΛΟΝΙΚΗΣ ΕΛΕΥΘΕΡΙΟ" },
  { value: 56429, label: "56429 ΘΕΣΣΑΛΟΝΙΚΗΣ ΠΟΛΙΧΝΗ" },
  { value: 56430, label: "56430 ΘΕΣΣΑΛΟΝΙΚΗΣ ΣΤΑΥΡΟΥΠΟΛΗ" },
  { value: 56431, label: "56431 ΘΕΣΣΑΛΟΝΙΚΗΣ ΕΥΟΣΜΟ" },
  { value: 56532, label: "56532 ΘΕΣΣΑΛΟΝΙΚΗΣ ΠΟΛΙΧΝΗ" },
  { value: 56533, label: "56533 ΘΕΣΣΑΛΟΝΙΚΗΣ ΠΟΛΙΧΝΗ" },
  { value: 56625, label: "56625 ΘΕΣΣΑΛΟΝΙΚΗΣ ΣΥΚΙΕΣ" },
  { value: 56626, label: "56626 ΘΕΣΣΑΛΟΝΙΚΗΣ ΣΥΚΙΕΣ" },
  { value: 56727, label: "56727 ΘΕΣΣΑΛΟΝΙΚΗΣ ΝΕΑΠΟΛΗ" },
  { value: 56728, label: "56728 ΘΕΣΣΑΛΟΝΙΚΗΣ ΝΕΑΠΟΛΗ" },
  { value: 57000, label: "57000 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΡΜΗ" },
  { value: 57001, label: "57001 ΘΕΣΣΑΛΟΝΙΚΗΣ ΘΕΡΜΗ" },
  { value: 57002, label: "57002 ΘΕΣΣΑΛΟΝΙΚΗΣ ΣΟΧΟΣ" },
  { value: 57003, label: "57003 ΘΕΣΣΑΛΟΝΙΚΗΣ ΑΓΙΟΣ ΑΘΑΝΑΣΙΟΣ" },
  { value: 57004, label: "57004 ΘΕΣΣΑΛΟΝΙΚΗΣ ΝΕΑ ΜΗΧΑΝΙΩΝΑ" },
  { value: 57006, label: "57006 ΘΕΣΣΑΛΟΝΙΚΗΣ ΒΑΣΙΛΙΚΑ ΘΕΣ.ΝΙΚΗΣ" },
  { value: 57007, label: "57007 ΘΕΣΣΑΛΟΝΙΚΗΣ ΧΑΛΚΗΔΩΝΑ" },
  { value: 57008, label: "57008 ΘΕΣΣΑΛΟΝΙΚΗΣ ΙΩΝΙΑ ΘΕΣ.ΝΙΚΗΣ" },
  { value: 57009, label: "57009 ΘΕΣΣΑΛΟΝΙΚΗΣ ΚΑΛΟΧΩΡΙ" },
  { value: 57010, label: "57010 ΘΕΣΣΑΛΟΝΙΚΗΣ ΑΣΒΕΣΤΟΧΩΡΙ" },
  { value: 57011, label: "57011 ΘΕΣΣΑΛΟΝΙΚΗΣ ΓΕΦΥΡΑ ΘΕΣ.ΝΙΚΗΣ" },
  { value: 57012, label: "57012 ΘΕΣΣΑΛΟΝΙΚΗΣ ΖΑΓΚΛΙΒΕΡΙ" },
  { value: 57013, label: "57013 ΘΕΣΣΑΛΟΝΙΚΗΣ ΩΡΑΙΟΚΑΣΤΡΟ" },
  { value: 57014, label: "57014 ΘΕΣΣΑΛΟΝΙΚΗΣ ΣΤΑΥΡΟΣ ΘΕΣΣ.ΝΙΚΗΣ" },
  { value: 57015, label: "57015 ΘΕΣΣΑΛΟΝΙΚΗΣ ΝΕΑ ΑΠΟΛΛΩΝΙΑ" },
  { value: 57016, label: "57016 ΘΕΣΣΑΛΟΝΙΚΗΣ ΑΣΚΟΣ" },
  { value: 57017, label: "57017 ΘΕΣΣΑΛΟΝΙΚΗΣ ΞΥΛΟΠΟΛΗ" },
  { value: 57018, label: "57018 ΘΕΣΣΑΛΟΝΙΚΗΣ ΜΕΛΙΣΣΟΧΩΡΙ" },
  { value: 57019, label: "57019 ΘΕΣΣΑΛΟΝΙΚΗΣ ΝΕΟΙ ΕΠΙΒΑΤΕΣ" },
  { value: 57020, label: "57020 ΘΕΣΣΑΛΟΝΙΚΗΣ ΛΑΓΚΑΔΙΚΙΑ" },
  { value: 57021, label: "57021 ΘΕΣΣΑΛΟΝΙΚΗΣ ΑΣΠΡΟΒΑΛΤΑ" },
  { value: 57022, label: "57022 ΘΕΣΣΑΛΟΝΙΚΗΣ ΒΙ.ΠΕ.Θ." },
  { value: 57100, label: "57100 ΘΕΣΣΑΛΟΝΙΚΗΣ ΚΟΥΦΑΛΙΑ" },
  { value: 57200, label: "57200 ΘΕΣΣΑΛΟΝΙΚΗΣ ΛΑΓΚΑΔΑΣ" },
  { value: 57300, label: "57300 ΘΕΣΣΑΛΟΝΙΚΗΣ ΧΑΛΑΣΤΡΑ" },
  { value: 57400, label: "57400 ΘΕΣΣΑΛΟΝΙΚΗΣ ΣΙΝΔΟΣ" },
  { value: 57500, label: "57500 ΘΕΣΣΑΛΟΝΙΚΗΣ ΕΠΑΝΟΜΗ" },
  { value: 58001, label: "58001 ΠΕΛΛΗΣ ΚΑΡΥΩΤΙΣΣΑ" },
  { value: 58002, label: "58002 ΠΕΛΛΗΣ ΑΡΝΙΣΣΑ" },
  { value: 58003, label: "58003 ΠΕΛΛΗΣ ΦΟΥΣΤΑΝΗ" },
  { value: 58004, label: "58004 ΠΕΛΛΗΣ ΕΞΑΠΛΑΤΑΝΟΣ" },
  { value: 58005, label: "58005 ΠΕΛΛΗΣ ΠΕΛΛΑ" },
  { value: 58100, label: "58100 ΠΕΛΛΗΣ ΓΙΑΝΝΙΤΣΑ" },
  { value: 58200, label: "58200 ΠΕΛΛΗΣ ΕΔΕΣΣΑ" },
  { value: 58300, label: "58300 ΠΕΛΛΗΣ ΚΡΥΑ ΒΡΥΣΗ" },
  { value: 58400, label: "58400 ΠΕΛΛΗΣ ΑΡΙΔΑΙΑ" },
  { value: 58500, label: "58500 ΠΕΛΛΗΣ ΣΚΥΔΡΑ" },
  { value: 59031, label: "59031 ΗΜΑΘΙΑΣ ΜΕΛΙΚΗ" },
  { value: 59032, label: "59032 ΗΜΑΘΙΑΣ Σ. Σ. ΠΛΑΤΕΟΣ" },
  { value: 59033, label: "59033 ΗΜΑΘΙΑΣ ΜΑΚΡΟΧΩΡΙ ΗΜΑΘΙΑΣ" },
  { value: 59034, label: "59034 ΗΜΑΘΙΑΣ ΕΙΡΗΝΟΥΠΟΛΗ" },
  { value: 59035, label: "59035 ΗΜΑΘΙΑΣ ΚΟΠΑΝΟΣ" },
  { value: 59100, label: "59100 ΗΜΑΘΙΑΣ ΒΕΡΟΙΑ" },
  { value: 59131, label: "59131 ΗΜΑΘΙΑΣ ΒΕΡΟΙΑ" },
  { value: 59132, label: "59132 ΗΜΑΘΙΑΣ ΒΕΡΟΙΑ" },
  { value: 59200, label: "59200 ΗΜΑΘΙΑΣ ΝΑΟΥΣΑ" },
  { value: 59300, label: "59300 ΗΜΑΘΙΑΣ ΑΛΕΞΑΝΔΡΕΙΑ" },
  { value: 60061, label: "60061 ΠΙΕΡΙΑΣ ΚΟΛΙΝΔΡΟΣ" },
  { value: 60062, label: "60062 ΠΙΕΡΙΑΣ ΚΟΡΙΝΟΣ" },
  { value: 60063, label: "60063 ΠΙΕΡΙΑΣ ΛΕΠΤΟΚΑΡΥΑ" },
  { value: 60064, label: "60064 ΠΙΕΡΙΑΣ ΚΙΤΡΟΣ" },
  { value: 60065, label: "60065 ΠΙΕΡΙΑΣ ΠΛΑΤΑΜΩΝΑΣ" },
  { value: 60066, label: "60066 ΠΙΕΡΙΑΣ ΜΕΘΩΝΗ" },
  { value: 60100, label: "60100 ΠΙΕΡΙΑΣ ΚΑΤΕΡΙΝΗ" },
  { value: 60131, label: "60131 ΠΙΕΡΙΑΣ ΚΑΤΕΡΙΝΗ" },
  { value: 60132, label: "60132 ΠΙΕΡΙΑΣ ΚΑΤΕΡΙΝΗ" },
  { value: 60133, label: "60133 ΠΙΕΡΙΑΣ ΚΑΤΕΡΙΝΗ" },
  { value: 60134, label: "60134 ΠΙΕΡΙΑΣ ΚΑΤΕΡΙΝΗ" },
  { value: 60150, label: "60150 ΠΙΕΡΙΑΣ ΕΛΑΤΟΧΩΡΙ"},
  { value: 60200, label: "60200 ΠΙΕΡΙΑΣ ΛΙΤΟΧΩΡΟ" },
  { value: 60300, label: "60300 ΠΙΕΡΙΑΣ ΑΙΓΙΝΙΟ" },
  { value: 61001, label: "61001 ΚΙΛΚΙΣ Σ. Σ. ΕΥΖΩΝΩΝ" },
  { value: 61002, label: "61002 ΚΙΛΚΙΣ ΧΕΡΣΟ" },
  { value: 61003, label: "61003 ΚΙΛΚΙΣ Σ. Σ. ΜΟΥΡΙΩΝ" },
  { value: 61005, label: "61005 ΚΙΛΚΙΣ ΕΙΔΟΜΕΝΗ" },
  { value: 61006, label: "61006 ΚΙΛΚΙΣ ΒΑΘΗ ΚΙΛΚΙΣ" },
  { value: 61007, label: "61007 ΚΙΛΚΙΣ ΕΥΡΩΠΟΣ" },
  { value: 61100, label: "61100 ΚΙΛΚΙΣ ΚΙΛΚΙΣ" },
  { value: 61200, label: "61200 ΚΙΛΚΙΣ ΠΟΛΥΚΑΣΤΡΟ" },
  { value: 61300, label: "61300 ΚΙΛΚΙΣ ΓΟΥΜΕΝΙΣΣΑ" },
  { value: 61400, label: "61400 ΚΙΛΚΙΣ ΑΞΙΟΥΠΟΛΗ" },
  { value: 62041, label: "62041 ΣΕΡΡΩΝ ΡΟΔΟΛΙΒΟΣ" },
  { value: 62042, label: "62042 ΣΕΡΡΩΝ ΝΕΑ ΖΙΧΝΗ" },
  { value: 62043, label: "62043 ΣΕΡΡΩΝ ΝΕΟ ΠΕΤΡΙΤΣΙ" },
  { value: 62044, label: "62044 ΣΕΡΡΩΝ ΝΕΟΣ ΣΚΟΠΟΣ" },
  { value: 62045, label: "62045 ΣΕΡΡΩΝ ΑΛΙΣΤΡΑΤΗ" },
  { value: 62046, label: "62046 ΣΕΡΡΩΝ ΧΡΥΣΟ" },
  { value: 62047, label: "62047 ΣΕΡΡΩΝ ΠΡΩΤΗ" },
  { value: 62048, label: "62048 ΣΕΡΡΩΝ ΠΕΝΤΑΠΟΛΗ" },
  { value: 62049, label: "62049 ΣΕΡΡΩΝ ΜΑΥΡΟΘΑΛΑΣΣΑ" },
  { value: 62050, label: "62050 ΣΕΡΡΩΝ ΓΑΖΩΡΟΣ" },
  { value: 62051, label: "62051 ΣΕΡΡΩΝ ΑΓΙΟ ΠΝΕΥΜΑ" },
  { value: 62052, label: "62052 ΣΕΡΡΩΝ ΔΡΑΒΗΣΚΟΣ" },
  { value: 62053, label: "62053 ΣΕΡΡΩΝ ΡΟΔΟΠΟΛΗ" },
  { value: 62054, label: "62054 ΣΕΡΡΩΝ ΣΤΡΥΜΟΝΙΚΟ" },
  { value: 62055, label: "62055 ΣΕΡΡΩΝ ΚΑΤΩ ΠΟΡΟΙΑ" },
  { value: 62056, label: "62056 ΣΕΡΡΩΝ Σ. Σ. ΑΓΓΙΣΤΑΣ" },
  { value: 62100, label: "62100 ΣΕΡΡΩΝ ΣΕΡΡΕΣ" },
  { value: 62121, label: "62121 ΣΕΡΡΩΝ ΣΕΡΡΕΣ" },
  { value: 62122, label: "62122 ΣΕΡΡΩΝ ΣΕΡΡΕΣ" },
  { value: 62123, label: "62123 ΣΕΡΡΩΝ ΣΕΡΡΕΣ" },
  { value: 62124, label: "62124 ΣΕΡΡΩΝ ΣΕΡΡΕΣ" },
  { value: 62125, label: "62125 ΣΕΡΡΩΝ ΣΕΡΡΕΣ" },
  { value: 62200, label: "62200 ΣΕΡΡΩΝ ΣΕΡΡΕΣ" },
  { value: 62300, label: "62300 ΣΕΡΡΩΝ ΣΙΔΗΡΟΚΑΣΤΡΟ" },
  { value: 62400, label: "62400 ΣΕΡΡΩΝ ΗΡΑΚΛΕΙΑ" },
  { value: 63071, label: "63071 ΧΑΛΚΙΔΙΚΗΣ ΟΡΜΥΛΙΑ" },
  { value: 63072, label: "63072 ΧΑΛΚΙΔΙΚΗΣ ΣΥΚΕΑ" },
  { value: 63073, label: "63073 ΧΑΛΚΙΔΙΚΗΣ ΓΑΛΑΤΙΣΤΑ" },
  { value: 63074, label: "63074 ΧΑΛΚΙΔΙΚΗΣ ΑΡΝΑΙΑ" },
  { value: 63075, label: "63075 ΧΑΛΚΙΔΙΚΗΣ ΙΕΡΙΣΣΟΣ" },
  { value: 63076, label: "63076 ΧΑΛΚΙΔΙΚΗΣ ΜΕΓΑΛΗ ΠΑΝΑΓΙΑ" },
  { value: 63077, label: "63077 ΧΑΛΚΙΔΙΚΗΣ ΚΑΣΣΑΝΔΡΕΙΑ" },
  { value: 63078, label: "63078 ΧΑΛΚΙΔΙΚΗΣ ΑΓΙΟΣ ΝΙΚΟΛΑΟΣ" },
  { value: 63079, label: "63079 ΧΑΛΚΙΔΙΚΗΣ ΝΕΑ ΤΡΙΓΛΙΑ" },
  { value: 63080, label: "63080 ΧΑΛΚΙΔΙΚΗΣ ΝΕΑ ΚΑΛΛΙΚΡΑΤΕΙΑ" },
  { value: 63081, label: "63081 ΧΑΛΚΙΔΙΚΗΣ ΝΕΟΣ ΜΑΡΜΑΡΑΣ" },
  { value: 63082, label: "63082 ΧΑΛΚΙΔΙΚΗΣ ΣΤΡΑΤΩΝΙΟ" },
  { value: 63083, label: "63083 ΧΑΛΚΙΔΙΚΗΣ ΣΤΡΑΤΟΝΙΚΗ" },
  { value: 63084, label: "63084 ΧΑΛΚΙΔΙΚΗΣ ΒΑΒΔΟΣ" },
  { value: 63085, label: "63085 ΧΑΛΚΙΔΙΚΗΣ ΠΕΥΚΟΧΩΡΙ" },
  { value: 63086, label: "63086 ΧΑΛΚΙΔΙΚΗΣ ΚΑΡΥΕΣ ΑΓΙΟΥ ΟΡΟΥΣ" },
  { value: 63087, label: "63087 ΧΑΛΚΙΔΙΚΗΣ ΔΑΦΝΗ ΑΓΙΟΥ ΟΡΟΥΣ" },
  { value: 63088, label: "63088 ΧΑΛΚΙΔΙΚΗΣ ΝΙΚΗΤΗ" },
  { value: 63100, label: "63100 ΧΑΛΚΙΔΙΚΗΣ ΠΟΛΥΓΥΡΟΣ" },
  { value: 63200, label: "63200 ΧΑΛΚΙΔΙΚΗΣ ΝΕΑ ΜΟΥΔΑΝΙΑ" },
  { value: 64001, label: "64001 ΚΑΒΑΛΑΣ ΝΙΚΗΣΙΑΝΗ" },
  { value: 64002, label: "64002 ΚΑΒΑΛΑΣ ΛΙΜΕΝΑΡΙΑ" },
  { value: 64003, label: "64003 ΚΑΒΑΛΑΣ ΚΡΗΝΙΔΕΣ" },
  { value: 64004, label: "64004 ΚΑΒΑΛΑΣ ΘΑΣΟΣ" },
  { value: 64005, label: "64005 ΚΑΒΑΛΑΣ ΘΕΟΛΟΓΟΣ" },
  { value: 64006, label: "64006 ΚΑΒΑΛΑΣ Ν. ΚΑΡΒΑΛΗ" },
  { value: 64007, label: "64007 ΚΑΒΑΛΑΣ ΝΕΑ ΠΕΡΑΜΟΣ" },
  { value: 64008, label: "64008 ΚΑΒΑΛΑΣ ΜΟΥΣΘΕΝΗ" },
  { value: 64009, label: "64009 ΚΑΒΑΛΑΣ ΚΕΧΡΟΚΑΜΠΟΣ" },
  { value: 64010, label: "64010 ΚΑΒΑΛΑΣ ΠΡΙΝΟΣ" },
  { value: 64011, label: "64011 ΚΑΒΑΛΑΣ ΚΕΡΑΜΩΤΗ" },
  { value: 64012, label: "64012 ΚΑΒΑΛΑΣ ΑΜΥΓΔΑΛΕΩΝΑΣ" },
  { value: 64100, label: "64100 ΚΑΒΑΛΑΣ ΕΛΕΥΘΕΡΟΥΠΟΛΗ" },
  { value: 64200, label: "64200 ΚΑΒΑΛΑΣ ΧΡΥΣΟΥΠΟΛΗ" },
  { value: 65201, label: "65201 ΚΑΒΑΛΑΣ ΚΑΒΑΛΑ" },
  { value: 65302, label: "65302 ΚΑΒΑΛΑΣ ΚΑΒΑΛΑ" },
  { value: 65403, label: "65403 ΚΑΒΑΛΑΣ ΚΑΒΑΛΑ" },
  { value: 65404, label: "65404 ΚΑΒΑΛΑΣ ΚΑΒΑΛΑ" },
  { value: 65500, label: "65500 ΚΑΒΑΛΑΣ ΚΑΒΑΛΑ" },
  { value: 66031, label: "66031 ΔΡΑΜΑΣ ΚΑΛΑΜΠΑΚΙ" },
  { value: 66032, label: "66032 ΔΡΑΜΑΣ ΚΥΡΙΑ" },
  { value: 66033, label: "66033 ΔΡΑΜΑΣ Κ. ΝΕΥΡΟΚΟΠΙ" },
  { value: 66034, label: "66034 ΔΡΑΜΑΣ ΦΩΤΟΛΙΒΟΣ" },
  { value: 66035, label: "66035 ΔΡΑΜΑΣ ΠΑΡΑΝΕΣΤΙ" },
  { value: 66036, label: "66036 ΔΡΑΜΑΣ ΜΙΚΡΟΠΟΛΗ" },
  { value: 66037, label: "66037 ΔΡΑΜΑΣ ΝΙΚΗΦΟΡΟΣ" },
  { value: 66038, label: "66038 ΔΡΑΜΑΣ ΣΙΔΗΡΟΝΕΡΟ" },
  { value: 66100, label: "66100 ΔΡΑΜΑΣ ΔΡΑΜΑ" },
  { value: 66131, label: "66131 ΔΡΑΜΑΣ ΔΡΑΜΑ" },
  { value: 66132, label: "66132 ΔΡΑΜΑΣ ΔΡΑΜΑ" },
  { value: 66133, label: "66133 ΔΡΑΜΑΣ ΔΡΑΜΑ" },
  { value: 66200, label: "66200 ΔΡΑΜΑΣ ΠΡΟΣΟΤΣΑΝΗ" },
  { value: 66300, label: "66300 ΔΡΑΜΑΣ ΔΟΞΑΤΟ" },
  { value: 67061, label: "67061 ΞΑΝΘΗΣ ΑΒΔΗΡΑ" },
  { value: 67062, label: "67062 ΞΑΝΘΗΣ ΣΤΑΥΡΟΥΠΟΛΗ ΞΑΝΘΗΣ" },
  { value: 67063, label: "67063 ΞΑΝΘΗΣ ΛΑΓΟΣ" },
  { value: 67064, label: "67064 ΞΑΝΘΗΣ ΓΕΝΙΣΕΑ" },
  { value: 67100, label: "67100 ΞΑΝΘΗΣ ΞΑΝΘΗ" },
  { value: 67131, label: "67131 ΞΑΝΘΗΣ ΞΑΝΘΗ" },
  { value: 67132, label: "67132 ΞΑΝΘΗΣ ΞΑΝΘΗ" },
  { value: 67133, label: "67133 ΞΑΝΘΗΣ ΞΑΝΘΗ" },
  { value: 67200, label: "67200 ΞΑΝΘΗΣ ΕΥΛΑΛΟ" },
  { value: 67300, label: "67300 ΞΑΝΘΗΣ ΕΧΙΝΟΣ" },
  { value: 68001, label: "68001 ΕΒΡΟΥ ΝΕΑ ΒΥΣΣΑ" },
  { value: 68002, label: "68002 ΕΒΡΟΥ ΣΑΜΟΘΡΑΚΗ" },
  { value: 68003, label: "68003 ΕΒΡΟΥ ΤΥΧΕΡΟ" },
  { value: 68004, label: "68004 ΕΒΡΟΥ ΛΑΒΑΡΑ" },
  { value: 68005, label: "68005 ΕΒΡΟΥ ΜΙΚΡΟ ΔΕΡΕΙΟ" },
  { value: 68006, label: "68006 ΕΒΡΟΥ ΚΥΠΡΙΝΟΣ" },
  { value: 68007, label: "68007 ΕΒΡΟΥ ΔΙΚΑΙΑ" },
  { value: 68008, label: "68008 ΕΒΡΟΥ ΚΑΣΤΑΝΙΕΣ ΕΒΡΟΥ" },
  { value: 68009, label: "68009 ΕΒΡΟΥ Σ. Σ. ΠΥΘΙΟΥ" },
  { value: 68010, label: "68010 ΕΒΡΟΥ ΜΕΤΑΞΑΔΕΣ" },
  { value: 68011, label: "68011 ΕΒΡΟΥ ΑΙΣΥΜΗ" },
  { value: 68012, label: "68012 ΕΒΡΟΥ ΓΕΦΥΡΑ ΚΗΠΩΝ" },
  { value: 68013, label: "68013 ΕΒΡΟΥ ΠΕΠΛΟΣ" },
  { value: 68014, label: "68014 ΕΒΡΟΥ ΡΙΖΙΑ" },
  { value: 68100, label: "68100 ΕΒΡΟΥ ΑΛΕΞΑΝΔΡΟΥΠΟΛΗ" },
  { value: 68131, label: "68131 ΕΒΡΟΥ ΑΛΕΞΑΝΔΡΟΥΠΟΛΗ" },
  { value: 68132, label: "68132 ΕΒΡΟΥ ΑΛΕΞΑΝΔΡΟΥΠΟΛΗ" },
  { value: 68133, label: "68133 ΕΒΡΟΥ ΑΛΕΞΑΝΔΡΟΥΠΟΛΗ" },
  { value: 68200, label: "68200 ΕΒΡΟΥ ΟΡΕΣΤΙΑΔΑ" },
  { value: 68300, label: "68300 ΕΒΡΟΥ ΔΙΔΥΜΟΤΕΙΧΟ" },
  { value: 68400, label: "68400 ΕΒΡΟΥ ΣΟΥΦΛΙ" },
  { value: 68500, label: "68500 ΕΒΡΟΥ ΦΕΡΕΣ" },
  { value: 69100, label: "69100 ΡΟΔΟΠΗΣ ΚΟΜΟΤΗΝΗ" },
  { value: 69131, label: "69131 ΡΟΔΟΠΗΣ ΚΟΜΟΤΗΝΗ" },
  { value: 69132, label: "69132 ΡΟΔΟΠΗΣ ΚΟΜΟΤΗΝΗ" },
  { value: 69133, label: "69133 ΡΟΔΟΠΗΣ ΚΟΜΟΤΗΝΗ" },
  { value: 69200, label: "69200 ΡΟΔΟΠΗΣ ΙΑΣΜΟΣ" },
  { value: 69300, label: "69300 ΡΟΔΟΠΗΣ ΣΑΠΕΣ" },
  { value: 69400, label: "69400 ΡΟΔΟΠΗΣ ΞΥΛΑΓΑΝΗ" },
  { value: 69500, label: "69500 ΡΟΔΟΠΗΣ ΟΡΓΑΝΗ" },
  { value: 70001, label: "70001 ΗΡΑΚΛΕΙΟΥ ΚΡΟΥΣΩΝΑΣ" },
  { value: 70002, label: "70002 ΗΡΑΚΛΕΙΟΥ ΖΑΡΟΣ" },
  { value: 70003, label: "70003 ΗΡΑΚΛΕΙΟΥ ΑΓΙΑ ΒΑΡΒΑΡΑ ΗΡΑΚΛΕΙ" },
  { value: 70004, label: "70004 ΗΡΑΚΛΕΙΟΥ ΑΝΩ ΒΙΑΝΝΟΣ" },
  { value: 70005, label: "70005 ΗΡΑΚΛΕΙΟΥ ΜΟΧΟΣ" },
  { value: 70006, label: "70006 ΗΡΑΚΛΕΙΟΥ ΚΑΣΤΕΛΛΙ" },
  { value: 70007, label: "70007 ΗΡΑΚΛΕΙΟΥ ΜΑΛΙΑ" },
  { value: 70008, label: "70008 ΗΡΑΚΛΕΙΟΥ ΕΠΙΣΚΟΠΗ ΗΡΑΚΛΕΙΟΥ" },
  { value: 70009, label: "70009 ΗΡΑΚΛΕΙΟΥ ΠΟΜΠΙΑ" },
  { value: 70010, label: "70010 ΗΡΑΚΛΕΙΟΥ ΠΥΡΓΟΣ ΜΟΝΟΦΑΤΣΙΟΥ" },
  { value: 70011, label: "70011 ΗΡΑΚΛΕΙΟΥ ΔΑΦΝΕΣ" },
  { value: 70012, label: "70012 ΗΡΑΚΛΕΙΟΥ ΑΓΙΟΙ ΔΕΚΑ" },
  { value: 70013, label: "70013 ΗΡΑΚΛΕΙΟΥ ΑΓΙΟΣ ΜΥΡΩΝΑΣ" },
  { value: 70014, label: "70014 ΗΡΑΚΛΕΙΟΥ ΛΙΜΕΝΑΣ ΧΕΡΣΟΝΗΣΟΥ" },
  { value: 70015, label: "70015 ΗΡΑΚΛΕΙΟΥ ΕΜΠΑΡΟΣ" },
  { value: 70016, label: "70016 ΗΡΑΚΛΕΙΟΥ ΑΣΗΜΙ" },
  { value: 70017, label: "70017 ΗΡΑΚΛΕΙΟΥ ΓΕΡΓΕΡΗ" },
  { value: 70100, label: "70100 ΗΡΑΚΛΕΙΟΥ ΑΡΧΑΝΕΣ" },
  { value: 70200, label: "70200 ΗΡΑΚΛΕΙΟΥ ΤΥΜΠΑΚΙ" },
  { value: 70300, label: "70300 ΗΡΑΚΛΕΙΟΥ ΑΡΚΑΛΟΧΩΡΙ" },
  { value: 70400, label: "70400 ΗΡΑΚΛΕΙΟΥ ΜΟΙΡΕΣ" },
  { value: 71201, label: "71201 ΗΡΑΚΛΕΙΟΥ ΗΡΑΚΛΕΙΟ" },
  { value: 71202, label: "71202 ΗΡΑΚΛΕΙΟΥ ΗΡΑΚΛΕΙΟ" },
  { value: 71303, label: "71303 ΗΡΑΚΛΕΙΟΥ ΗΡΑΚΛΕΙΟ" },
  { value: 71304, label: "71304 ΗΡΑΚΛΕΙΟΥ ΗΡΑΚΛΕΙΟ" },
  { value: 71305, label: "71305 ΗΡΑΚΛΕΙΟΥ ΗΡΑΚΛΕΙΟ" },
  { value: 71306, label: "71306 ΗΡΑΚΛΕΙΟΥ ΗΡΑΚΛΕΙΟ" },
  { value: 71307, label: "71307 ΗΡΑΚΛΕΙΟΥ ΗΡΑΚΛΕΙΟ" },
  { value: 71309, label: "71309 ΗΡΑΚΛΕΙΟΥ ΗΡΑΚΛΕΙΟ" },
  { value: 71409, label: "71409 ΗΡΑΚΛΕΙΟΥ ΗΡΑΚΛΕΙΟ" },
  { value: 71410, label: "71410 ΗΡΑΚΛΕΙΟΥ ΗΡΑΚΛΕΙΟ" },
  { value: 71414, label: "71414 ΗΡΑΚΛΕΙΟΥ ΓΑΖΙ" },
  { value: 71500, label: "71500 ΗΡΑΚΛΕΙΟΥ ΗΡΑΚΛΕΙΟ" },
  { value: 71601, label: "71601 ΗΡΑΚΛΕΙΟΥ Ν.ΑΛΙΚΑΡΝΑΣΣΟΣ" },
  { value: 72051, label: "72051 ΛΑΣΙΘΙΟΥ ΚΡΙΤΣΑ" },
  { value: 72052, label: "72052 ΛΑΣΙΘΙΟΥ ΤΖΕΡΜΙΑΔΟ" },
  { value: 72053, label: "72053 ΛΑΣΙΘΙΟΥ ΕΛΟΥΝΤΑ" },
  { value: 72054, label: "72054 ΛΑΣΙΘΙΟΥ ΒΡΑΧΑΣΙ" },
  { value: 72055, label: "72055 ΛΑΣΙΘΙΟΥ ΣΤΑΥΡΟΧΩΡΙ" },
  { value: 72056, label: "72056 ΛΑΣΙΘΙΟΥ ΜΑΛΕΣ" },
  { value: 72057, label: "72057 ΛΑΣΙΘΙΟΥ ΤΟΥΡΛΩΤΗ" },
  { value: 72058, label: "72058 ΛΑΣΙΘΙΟΥ ΦΟΥΡΝΗ" },
  { value: 72059, label: "72059 ΛΑΣΙΘΙΟΥ ΧΑΝΔΡΑΣ" },
  { value: 72100, label: "72100 ΛΑΣΙΘΙΟΥ ΑΓΙΟΣ ΝΙΚΟΛΑΟΣ" },
  { value: 72200, label: "72200 ΛΑΣΙΘΙΟΥ ΙΕΡΑΠΕΤΡΑ" },
  { value: 72300, label: "72300 ΛΑΣΙΘΙΟΥ ΣΗΤΕΙΑ" },
  { value: 72400, label: "72400 ΛΑΣΙΘΙΟΥ ΝΕΑΠΟΛΗ ΚΡΗΤΗΣ" },
  { value: 73001, label: "73001 ΧΑΝΙΩΝ ΠΑΛΑΙΟΧΩΡΑ" },
  { value: 73002, label: "73002 ΧΑΝΙΩΝ ΒΟΥΚΟΛΙΕΣ" },
  { value: 73003, label: "73003 ΧΑΝΙΩΝ ΚΑΛΥΒΕΣ" },
  { value: 73004, label: "73004 ΧΑΝΙΩΝ ΚΑΝΔΑΝΟΣ" },
  { value: 73005, label: "73005 ΧΑΝΙΩΝ ΑΛΙΚΙΑΝΟΣ" },
  { value: 73006, label: "73006 ΧΑΝΙΩΝ ΚΟΛΥΜΒΑΡΙ" },
  { value: 73007, label: "73007 ΧΑΝΙΩΝ ΒΡΥΣΕΣ" },
  { value: 73008, label: "73008 ΧΑΝΙΩΝ ΒΑΜΟΣ" },
  { value: 73009, label: "73009 ΧΑΝΙΩΝ ΡΟΔΟΒΑΝΙ" },
  { value: 73010, label: "73010 ΧΑΝΙΩΝ ΤΟΠΟΛΙΑ" },
  { value: 73011, label: "73011 ΧΑΝΙΩΝ ΧΩΡΑ ΣΦΑΚΙΩΝ" },
  { value: 73012, label: "73012 ΧΑΝΙΩΝ ΒΑΘΗ ΧΑΝΙΩΝ" },
  { value: 73013, label: "73013 ΧΑΝΙΩΝ ΑΣΚΥΦΟΥ" },
  { value: 73014, label: "73014 ΧΑΝΙΩΝ ΠΛΑΤΑΝΙΑΣ" },
  { value: 73100, label: "73100 ΧΑΝΙΩΝ ΧΑΝΙΑ" },
  { value: 73131, label: "73131 ΧΑΝΙΩΝ ΧΑΝΙΑ" },
  { value: 73132, label: "73132 ΧΑΝΙΩΝ ΧΑΝΙΑ" },
  { value: 73133, label: "73133 ΧΑΝΙΩΝ ΧΑΝΙΑ" },
  { value: 73134, label: "73134 ΧΑΝΙΩΝ ΧΑΝΙΑ" },
  { value: 73135, label: "73135 ΧΑΝΙΩΝ ΧΑΝΙΑ" },
  { value: 73136, label: "73136 ΧΑΝΙΩΝ ΧΑΝΙΑ" },
  { value: 73200, label: "73200 ΧΑΝΙΩΝ ΣΟΥΔΑ" },
  { value: 73300, label: "73300 ΧΑΝΙΩΝ ΜΟΥΡΝΙΕΣ" },
  { value: 73400, label: "73400 ΧΑΝΙΩΝ ΚΙΣΣΑΜΟΣ" },
  { value: 74000, label: "74000 ΡΕΘΥΜΝΗΣ ΜΥΡΘΙΟΣ" },
  { value: 74051, label: "74051 ΡΕΘΥΜΝΗΣ ΑΝΩΓΕΙΑ" },
  { value: 74052, label: "74052 ΡΕΘΥΜΝΗΣ ΠΕΡΑΜΑ ΡΕΘΥΜΝΗΣ" },
  { value: 74053, label: "74053 ΡΕΘΥΜΝΗΣ ΣΠΗΛΙ" },
  { value: 74054, label: "74054 ΡΕΘΥΜΝΗΣ ΓΑΡΑΖΟ" },
  { value: 74055, label: "74055 ΡΕΘΥΜΝΗΣ ΕΠΙΣΚΟΠΗ ΡΕΘΥΜΝΗΣ" },
  { value: 74056, label: "74056 ΡΕΘΥΜΝΗΣ ΑΓΙΑ ΓΑΛΗΝΗ" },
  { value: 74057, label: "74057 ΡΕΘΥΜΝΗΣ ΠΑΝΟΡΜΟΣ ΡΕΘΥΜΝΗΣ" },
  { value: 74058, label: "74058 ΡΕΘΥΜΝΗΣ ΡΟΥΣΤΙΚΑ" },
  { value: 74059, label: "74059 ΡΕΘΥΜΝΗΣ ΑΠΟΔΟΥΛΟΥ" },
  { value: 74060, label: "74060 ΡΕΘΥΜΝΗΣ ΜΥΡΘΙΟΣ" },
  { value: 74061, label: "74061 ΡΕΘΥΜΝΗΣ ΑΜΑΡΙ" },
  { value: 74062, label: "74062 ΡΕΘΥΜΝΗΣ ΒΙΖΑΡΙ" },
  { value: 74100, label: "74100 ΡΕΘΥΜΝΗΣ ΡΕΘΥΜΝΟ" },
  { value: 74131, label: "74131 ΡΕΘΥΜΝΗΣ ΡΕΘΥΜΝΟ" },
  { value: 74132, label: "74132 ΡΕΘΥΜΝΗΣ ΡΕΘΥΜΝΟ" },
  { value: 74133, label: "74133 ΡΕΘΥΜΝΗΣ ΡΕΘΥΜΝΟ" },
  { value: 80100, label: "80100 ΑΤΤΙΚΗΣ ΚΥΘΗΡΑ" },
  { value: 80200, label: "80200 ΑΤΤΙΚΗΣ ΠΟΤΑΜΟΣ" },
  { value: 81100, label: "81100 ΛΕΣΒΟΥ ΜΥΤΙΛΗΝΗ" },
  { value: 81101, label: "81101 ΛΕΣΒΟΥ ΑΓΙΑΣΟΣ" },
  { value: 81102, label: "81102 ΛΕΣΒΟΥ ΑΓΙΑ ΠΑΡΑΣΚΕΥΗ ΛΕΣΒΟ" },
  { value: 81103, label: "81103 ΛΕΣΒΟΥ ΑΝΤΙΣΣΑ" },
  { value: 81104, label: "81104 ΛΕΣΒΟΥ ΜΑΝΤΑΜΑΔΟΣ" },
  { value: 81105, label: "81105 ΛΕΣΒΟΥ ΕΡΕΣΟΣ" },
  { value: 81106, label: "81106 ΛΕΣΒΟΥ ΠΑΠΠΑΔΟΣ" },
  { value: 81107, label: "81107 ΛΕΣΒΟΥ ΚΑΛΛΟΝΗ" },
  { value: 81108, label: "81108 ΛΕΣΒΟΥ ΜΗΘΥΜΝΑ" },
  { value: 81109, label: "81109 ΛΕΣΒΟΥ ΠΕΤΡΑ" },
  { value: 81110, label: "81110 ΛΕΣΒΟΥ ΒΑΤΟΥΣΑ" },
  { value: 81111, label: "81111 ΛΕΣΒΟΥ ΠΕΡΑΜΑ ΛΕΣΒΟΥ" },
  { value: 81112, label: "81112 ΛΕΣΒΟΥ ΣΙΓΡΙΟ" },
  { value: 81113, label: "81113 ΛΕΣΒΟΥ ΦΙΛΙΑ" },
  { value: 81131, label: "81131 ΛΕΣΒΟΥ ΜΥΤΙΛΗΝΗ" },
  { value: 81132, label: "81132 ΛΕΣΒΟΥ ΜΥΤΙΛΗΝΗ" },
  { value: 81200, label: "81200 ΛΕΣΒΟΥ ΠΛΩΜΑΡΙ" },
  { value: 81300, label: "81300 ΛΕΣΒΟΥ ΠΟΛΙΧΝΙΤΟΣ" },
  { value: 81400, label: "81400 ΛΕΣΒΟΥ ΜΥΡΙΝΑ" },
  { value: 81401, label: "81401 ΛΕΣΒΟΥ ΜΟΥΔΡΟΣ" },
  { value: 81500, label: "81500 ΛΕΣΒΟΥ ΑΓΙΟΣ ΕΥΣΤΡΑΤΙΟΣ" },
  { value: 82100, label: "82100 ΧΙΟΥ ΧΙΟΣ" },
  { value: 82101, label: "82101 ΧΙΟΥ ΟΙΝΟΥΣΣΕΣ" },
  { value: 82102, label: "82102 ΧΙΟΥ ΚΑΛΑΜΩΤΗ" },
  { value: 82103, label: "82103 ΧΙΟΥ ΒΟΛΙΣΣΟΣ" },
  { value: 82104, label: "82104 ΧΙΟΥ ΨΑΡΑ" },
  { value: 82131, label: "82131 ΧΙΟΥ ΧΙΟΣ" },
  { value: 82132, label: "82132 ΧΙΟΥ ΧΙΟΣ" },
  { value: 82200, label: "82200 ΧΙΟΥ ΒΡΟΝΤΑΔΟΣ" },
  { value: 82300, label: "82300 ΧΙΟΥ ΚΑΡΔΑΜΥΛΑ" },
  { value: 83100, label: "83100 ΣΑΜΟΥ ΣΑΜΟΣ" },
  { value: 83101, label: "83101 ΣΑΜΟΥ ΜΥΤΙΛΗΝΙΟΙ" },
  { value: 83102, label: "83102 ΣΑΜΟΥ ΜΑΡΑΘΟΚΑΜΠΟΣ" },
  { value: 83103, label: "83103 ΣΑΜΟΥ ΠΥΘΑΓΟΡΕΙΟ" },
  { value: 83104, label: "83104 ΣΑΜΟΥ ΠΥΡΓΟΣ ΣΑΜΟΥ" },
  { value: 83200, label: "83200 ΣΑΜΟΥ ΚΑΡΛΟΒΑΣΙ" },
  { value: 83300, label: "83300 ΣΑΜΟΥ ΑΓΙΟΣ ΚΗΡΥΚΟΣ" },
  { value: 83301, label: "83301 ΣΑΜΟΥ ΡΑΧΕΣ" },
  { value: 83302, label: "83302 ΣΑΜΟΥ ΕΥΔΗΛΟΣ" },
  { value: 83400, label: "83400 ΣΑΜΟΥ ΦΟΥΡΝΟΙ" },
  { value: 84001, label: "84001 ΚΥΚΛΑΔΩΝ ΙΟΣ" },
  { value: 84002, label: "84002 ΚΥΚΛΑΔΩΝ ΙΟΥΛΙΣ" },
  { value: 84003, label: "84003 ΚΥΚΛΑΔΩΝ ΣΙΦΝΟΣ" },
  { value: 84004, label: "84004 ΚΥΚΛΑΔΩΝ ΚΙΜΩΛΟΣ" },
  { value: 84005, label: "84005 ΚΥΚΛΑΔΩΝ ΣΕΡΙΦΟΣ" },
  { value: 84006, label: "84006 ΚΥΚΛΑΔΩΝ ΚΥΘΝΟΣ" },
  { value: 84007, label: "84007 ΚΥΚΛΑΔΩΝ ΑΝΤΙΠΑΡΟΣ" },
  { value: 84008, label: "84008 ΚΥΚΛΑΔΩΝ ΑΜΟΡΓΟΣ" },
  { value: 84009, label: "84009 ΚΥΚΛΑΔΩΝ ΑΝΑΦΗ" },
  { value: 84010, label: "84010 ΚΥΚΛΑΔΩΝ ΣΙΚΙΝΟΣ" },
  { value: 84011, label: "84011 ΚΥΚΛΑΔΩΝ ΦΟΛΕΓΑΝΔΡΟΣ" },
  { value: 84100, label: "84100 ΚΥΚΛΑΔΩΝ ΣΥΡΟΣ" },
  { value: 84200, label: "84200 ΚΥΚΛΑΔΩΝ ΤΗΝΟΣ" },
  { value: 84201, label: "84201 ΚΥΚΛΑΔΩΝ ΠΑΝΟΡΜΟΣ ΤΗΝΟΥ" },
  { value: 84300, label: "84300 ΚΥΚΛΑΔΩΝ ΝΑΞΟΣ" },
  { value: 84301, label: "84301 ΚΥΚΛΑΔΩΝ ΚΟΡΩΝΙΔΑ" },
  { value: 84302, label: "84302 ΚΥΚΛΑΔΩΝ ΧΑΛΚΕΙΟ" },
  { value: 84400, label: "84400 ΚΥΚΛΑΔΩΝ ΠΑΡΟΣ" },
  { value: 84401, label: "84401 ΚΥΚΛΑΔΩΝ ΝΑΟΥΣΑ ΠΑΡΟΥ" },
  { value: 84500, label: "84500 ΚΥΚΛΑΔΩΝ ΑΝΔΡΟΣ" },
  { value: 84501, label: "84501 ΚΥΚΛΑΔΩΝ ΓΑΥΡΙΟ" },
  { value: 84502, label: "84502 ΚΥΚΛΑΔΩΝ ΚΟΡΘΙΟ" },
  { value: 84600, label: "84600 ΚΥΚΛΑΔΩΝ ΜΥΚΟΝΟΣ" },
  { value: 84700, label: "84700 ΚΥΚΛΑΔΩΝ ΘΗΡΑ" },
  { value: 84701, label: "84701 ΚΥΚΛΑΔΩΝ ΠΥΡΓΟΣ ΚΑΛΛΙΣΤ.ΘΗΡΑΣ" },
  { value: 84702, label: "84702 ΚΥΚΛΑΔΩΝ ΟΙΑ" },
  { value: 84703, label: "84703 ΚΥΚΛΑΔΩΝ ΕΜΠΟΡΕΙΟΝ" },
  { value: 84800, label: "84800 ΚΥΚΛΑΔΩΝ ΜΗΛΟΥ" },
  { value: 84801, label: "84801 ΚΥΚΛΑΔΩΝ ΑΔΑΜΑΣ" },
  { value: 85001, label: "85001 ΔΩΔΕΚΑΝΗΣΟΥ ΛΕΙΨΟΙ" },
  { value: 85002, label: "85002 ΔΩΔΕΚΑΝΗΣΟΥ ΤΗΛΟΣ" },
  { value: 85100, label: "85100 ΔΩΔΕΚΑΝΗΣΟΥ ΡΟΔΟΣ" },
  { value: 85101, label: "85101 ΔΩΔΕΚΑΝΗΣΟΥ ΙΑΛΥΣΟΣ" },
  { value: 85102, label: "85102 ΔΩΔΕΚΑΝΗΣΟΥ ΑΡΧΑΓΓΕΛΟΣ" },
  { value: 85103, label: "85103 ΔΩΔΕΚΑΝΗΣΟΥ ΑΦΑΝΤΟΥ" },
  { value: 85104, label: "85104 ΔΩΔΕΚΑΝΗΣΟΥ ΚΡΕΜΑΣΤΗ" },
  { value: 85105, label: "85105 ΔΩΔΕΚΑΝΗΣΟΥ ΚΑΛΥΘΙΕΣ" },
  { value: 85106, label: "85106 ΔΩΔΕΚΑΝΗΣΟΥ ΠΑΡΑΔΕΙΣΙ" },
  { value: 85107, label: "85107 ΔΩΔΕΚΑΝΗΣΟΥ ΛΙΝΔΟΣ" },
  { value: 85108, label: "85108 ΔΩΔΕΚΑΝΗΣΟΥ ΚΡΗΤΗΝΙΑ" },
  { value: 85109, label: "85109 ΔΩΔΕΚΑΝΗΣΟΥ ΓΕΝΝΑΔΙ" },
  { value: 85110, label: "85110 ΔΩΔΕΚΑΝΗΣΟΥ ΧΑΛΚΗ" },
  { value: 85111, label: "85111 ΔΩΔΕΚΑΝΗΣΟΥ ΜΕΓΙΣΤΗ.ΚΑΣΤΕΛΛΟΡΙΖΟ" },
  { value: 85131, label: "85131 ΔΩΔΕΚΑΝΗΣΟΥ ΡΟΔΟΣ" },
  { value: 85132, label: "85132 ΔΩΔΕΚΑΝΗΣΟΥ ΡΟΔΟΣ" },
  { value: 85133, label: "85133 ΔΩΔΕΚΑΝΗΣΟΥ ΡΟΔΟΣ" },
  { value: 85200, label: "85200 ΔΩΔΕΚΑΝΗΣΟΥ ΚΑΛΥΜΝΟΣ" },
  { value: 85300, label: "85300 ΔΩΔΕΚΑΝΗΣΟΥ ΚΩΣ" },
  { value: 85301, label: "85301 ΔΩΔΕΚΑΝΗΣΟΥ ΚΕΦΑΛΟΣ ΚΩ" },
  { value: 85302, label: "85302 ΔΩΔΕΚΑΝΗΣΟΥ ΑΝΤΙΜΑΧΕΙΑ" },
  { value: 85303, label: "85303 ΔΩΔΕΚΑΝΗΣΟΥ ΝΙΣΥΡΟΣ" },
  { value: 85400, label: "85400 ΔΩΔΕΚΑΝΗΣΟΥ ΛΕΡΟΣ" },
  { value: 85401, label: "85401 ΔΩΔΕΚΑΝΗΣΟΥ ΛΑΚΚΙ ΛΕΡΟΥ" },
  { value: 85500, label: "85500 ΔΩΔΕΚΑΝΗΣΟΥ ΠΑΤΜΟΣ" },
  { value: 85600, label: "85600 ΔΩΔΕΚΑΝΗΣΟΥ ΣΥΜΗ" },
  { value: 85700, label: "85700 ΔΩΔΕΚΑΝΗΣΟΥ ΚΑΡΠΑΘΟΣ" },
  { value: 85800, label: "85800 ΔΩΔΕΚΑΝΗΣΟΥ ΚΑΣΟΣ" },
  { value: 85900, label: "85900 ΔΩΔΕΚΑΝΗΣΟΥ ΑΣΤΥΠΑΛΑΙΑ" }
];

export default postalCodes;
